/* Español */
const es = {
  nav: {
    home: 'Inicio',
    imageConverter: 'Convertidor de Imágenes',
    imageCompressor: 'Compresor de Imágenes',
    otherTools: 'Otras Herramientas',
    resizeImage: 'Redimensionar Imagen',
    cropImage: 'Recortar Imagen',
    photoEditor: 'Editor de Fotos',
    removeBackground: 'Eliminar Fondo',
    watermarkImage: 'Marca de Agua',
    qrCodeGenerator: 'Generador de Código QR',
    qrCodeScanner: 'Escáner de Código QR',
    aboutUs: 'Sobre Nosotros',
    faceBlur: 'Desenfocar Rostro',
  },
  hero: {
    heading: 'Todas las Herramientas de Imagen que Necesitas',
    subheading: 'Herramientas en línea gratuitas para convertir, comprimir, redimensionar, recortar, editar y transformar tus imágenes. Todo el procesamiento ocurre en tu navegador — rápido, privado y seguro.',
  },
  tools: {
    compressImage: { title: 'Comprimir IMAGEN', desc: 'Comprime JPG, PNG, SVG y GIFs ahorrando espacio y manteniendo la calidad.' },
    resizeImage: { title: 'Redimensionar IMAGEN', desc: 'Define tus dimensiones, por porcentaje o píxel, y redimensiona tus imágenes JPG, PNG, SVG y GIF.' },
    cropImage: { title: 'Recortar IMAGEN', desc: 'Recorta JPG, PNG o GIFs con facilidad; elige píxeles para definir tu rectángulo o usa nuestro editor visual.' },
    convertToJpg: { title: 'Convertir a JPG', desc: 'Convierte imágenes PNG, GIF, TIF, PSD, SVG, WEBP, HEIC o RAW a JPG en lote con facilidad.' },
    convertFromJpg: { title: 'Convertir desde JPG', desc: 'Convierte imágenes JPG a PNG y GIF. ¡Elige varios JPGs para crear un GIF animado en segundos!' },
    qrCodeGenerator: { title: 'Generador de Código QR', desc: 'Genera códigos QR personalizados para URLs, texto, WiFi, contactos, correo electrónico y mapas.' },
    qrCodeScanner: { title: 'Escáner de Código QR', desc: 'Escanea códigos QR al instante usando tu cámara o subiendo una imagen.' },
    blurFace: { title: 'Desenfocar Rostro', desc: 'Detecta y desenfoca rostros automáticamente en tus imágenes para mayor privacidad.' },
    removeBackground: { title: 'Eliminar Fondo', desc: 'Elimina fondos de imágenes rápidamente con alta precisión.' },
    watermarkImage: { title: 'Marca de Agua', desc: 'Estampa una imagen o texto sobre tus imágenes en segundos.' },
  },
  whyChoose: {
    label: 'Por Qué Elegirnos',
    heading: 'La Forma Más Inteligente de Editar Imágenes',
    subheading: 'Miles de creadores, diseñadores y desarrolladores en todo el mundo confían en nosotros.',
    reasons: {
      fast: { title: 'Ultrarrápido', desc: 'Todo el procesamiento ocurre directamente en tu navegador. Sin subidas a servidores externos — los resultados aparecen en milisegundos.' },
      private: { title: '100% Privado y Seguro', desc: 'Tus archivos nunca salen de tu dispositivo. No almacenamos, compartimos ni accedemos a tus imágenes.' },
      noLimits: { title: 'Sin Límites, Sin Registro', desc: 'Usa cada herramienta cuantas veces quieras — completamente gratis. Sin cuenta, sin marcas de agua, sin costos ocultos.' },
      quality: { title: 'Calidad Profesional', desc: 'Nuestros algoritmos ofrecen resultados de calidad profesional. Comprime sin pérdida visible de calidad.' },
      batch: { title: 'Procesamiento por Lotes', desc: 'Maneja múltiples archivos a la vez. Convierte, comprime o redimensiona carpetas enteras de imágenes en una sola operación.' },
      everywhere: { title: 'Funciona en Todas Partes', desc: 'Diseño totalmente responsivo que funciona en escritorio, tableta y móvil. Sin descargas ni instalaciones.' },
    },
    stats: {
      imagesProcessed: 'Imágenes Procesadas',
      countriesServed: 'Países Atendidos',
      uptime: 'Tiempo Activo',
      freeTools: 'Herramientas Gratuitas',
    },
  },
  footer: {
    tagline: 'Herramientas de imagen en línea gratuitas — convierte, comprime, redimensiona, recorta y edita tus imágenes en segundos. Sin registro.',
    imageTools: 'Herramientas de Imagen',
    moreTools: 'Más Herramientas',
    company: 'Empresa',
    contact: 'Contacto',
    allRightsReserved: 'Todos los derechos reservados.',
    privacyPolicy: 'Política de Privacidad',
    termsOfService: 'Términos de Servicio',
  },
  faq: {
    badge: 'FAQ',
    heading: 'Preguntas Frecuentes',
    subheading: 'Respuestas rápidas a preguntas comunes sobre esta herramienta.',
    stillHaveQuestions: '¿Aún tienes preguntas? ¡Estamos aquí para ayudar!',
    reachOut: 'Contacta con Nuestro Equipo',
    questionHeader: 'Pregunta',
  },

  contactForm: {
    badge: 'Get in Touch',
    title: 'Contáctanos',
    subtitle: 'Nos encantaría saber de ti. ¡Envíanos un mensaje!',
    nameLabel: 'Nombre',
    namePlaceholder: 'Tu nombre completo',
    emailLabel: 'Correo electrónico',
    emailPlaceholder: 'tu@correo.com',
    subjectLabel: 'Asunto',
    subjectPlaceholder: '¿De qué se trata?',
    messageLabel: 'Mensaje',
    messagePlaceholder: 'Escribe tu mensaje aquí…',
    errName: 'El nombre es obligatorio',
    errEmail: 'El correo electrónico es obligatorio',
    errEmailInvalid: 'Introduce un correo válido',
    errSubject: 'El asunto es obligatorio',
    errMessage: 'El mensaje es obligatorio',
    sending: 'Enviando…',
    send: 'Enviar Mensaje',
    successTitle: '¡Mensaje Enviado!',
    successMsg: 'Gracias por contactarnos. Te responderemos pronto.',
    sendAnother: 'Enviar Otro',
    sendError: 'Algo salió mal. Por favor, inténtalo de nuevo.',
  },

  about: {
    label: 'Sobre Nosotros',
    heading: 'Hecho para Creadores, por Creadores',
    subheading: 'Creemos que las herramientas de imagen poderosas deben ser gratuitas, rápidas y accesibles para todos.',
    missionTitle: 'Nuestra Misión',
    missionText: 'photremium.com fue creado con un objetivo simple: ofrecer la experiencia de edición de imágenes más intuitiva, rápida y privada en la web. Procesamos todo directamente en tu navegador — tus archivos nunca salen de tu dispositivo.',
    privacyTitle: 'Privacidad Primero',
    privacyText: 'Nunca subimos, almacenamos ni procesamos tus imágenes en servidores remotos. Todo permanece en tu dispositivo.',
    techTitle: 'Tecnología Moderna',
    techText: 'Construido con tecnologías web de vanguardia incluyendo WebAssembly, Canvas API y React moderno para máximo rendimiento.',
    communityTitle: 'Impulsado por la Comunidad',
    communityText: 'Cada función que construimos está inspirada en los comentarios reales de los usuarios.',
    globalTitle: 'Alcance Global',
    globalText: 'Usado por creadores en más de 120 países. Disponible en múltiples idiomas con entrega CDN ultrarrápida.',
  },
  seo: {
    homeTitle: 'photremium.com — Convertidor, Compresor y Editor de Imágenes Gratis',
    homeDesc: 'Convierte, comprime, redimensiona, recorta y edita imágenes en línea gratis. Rápido, privado y seguro.',
    homeKeywords: 'convertidor de imágenes, compresor de imágenes, redimensionar imagen, recortar imagen, editor de fotos',
    aboutTitle: 'Sobre photremium.com — Nuestra Misión e Historia',
    aboutDesc: 'Conoce photremium.com, el kit de herramientas de imagen en línea gratuito en el que confían millones.',
    aboutKeywords: 'sobre photremium.com, herramientas de imagen, editor de imagen gratis',
  },

  privacyPolicyPage: {
    seo: {
      title: 'Política de Privacidad — Photremium | Sin cargas al servidor, almacenamiento cero',
      description: 'La Política de Privacidad de Photremium explica cómo protegemos tu privacidad. Todo el procesamiento ocurre en tu navegador: sin subidas de archivos, sin datos personales, sin rastreo.',
      ogTitle: 'Política de Privacidad — Photremium | Sin cargas, sin almacenamiento',
      ogDescription: 'Tus archivos permanecen en tu dispositivo. Photremium procesa todo localmente en tu navegador, sin contacto con servidores.',
      twitterTitle: 'Política de Privacidad — Photremium',
      twitterDescription: 'Herramientas 100% en navegador. Sin subidas, sin almacenamiento, sin rastreo.',
      schemaName: 'Política de Privacidad - Photremium',
      schemaDescription: 'Política de privacidad de Photremium: sin subidas al servidor, sin almacenamiento de datos.',
    },
    hero: {
      badge: 'Política de Privacidad',
      titlePrefix: 'Tu privacidad es nuestra',
      titleHighlight: 'máxima prioridad',
      subPrefix: 'photremium.com se basa en un principio simple —',
      subStrong: 'tus archivos nunca salen de tu dispositivo',
      subSuffix: 'Cada herramienta funciona completamente en tu navegador. Sin subidas. Sin nube. Sin compromisos.',
      effectiveLabel: 'Vigente desde',
      lastUpdatedLabel: 'Última actualización',
      worldwideLabel: 'Aplicable en todo el mundo',
    },
    trustCards: [
      { title: 'Sin cargas al servidor', desc: 'Tus archivos no salen de tu dispositivo. Todo el procesamiento es local.' },
      { title: 'Almacenamiento cero', desc: 'No guardamos nada sobre ti, tus imágenes o tu actividad.' },
      { title: 'Sin rastreo', desc: 'Sin seguimiento de comportamiento, sin huellas digitales, sin perfiles.' },
      { title: 'Compatible con GDPR', desc: 'Diseñado para respetar regulaciones globales de privacidad.' },
    ],
    contentsTitle: 'Contenido',
    toc: {
      overview: 'Resumen',
      'no-upload': 'Sin procesamiento en servidor',
      'data-collect': 'Datos que recopilamos',
      cookies: 'Cookies y almacenamiento',
      'third-party': 'Servicios de terceros',
      analytics: 'Analítica',
      children: 'Privacidad de menores',
      rights: 'Tus derechos',
      security: 'Seguridad',
      changes: 'Cambios de la política',
      contact: 'Contáctanos',
    },
    sections: {
      overview: {
        title: '1. Resumen',
        subtitle: 'Qué cubre esta política',
        p1Prefix: 'Esta Política de Privacidad describe cómo',
        p1Middle: '("nosotros", "nos" o "nuestro") maneja - o, más exactamente,',
        p1Italic: 'no maneja',
        p1Suffix: 'tu información personal cuando usas nuestras herramientas gratuitas de imagen en',
        p2: 'A diferencia de las aplicaciones web tradicionales que envían archivos a servidores remotos para procesarlos, photremium.com utiliza APIs modernas del navegador (Canvas API, WebAssembly y WebWorkers) para realizar cada operación localmente en tu dispositivo. El resultado: sin transmisión de datos, sin almacenamiento y sin riesgo.',
        calloutLabel: 'Resumen en lenguaje simple:',
        calloutText: 'No podemos ver tus imágenes, no queremos hacerlo, y nuestra tecnología está diseñada específicamente para que nunca podamos hacerlo.',
      },
      noUpload: {
        title: '2. Sin procesamiento en servidor — nunca',
        subtitle: 'Cómo funcionan realmente nuestras herramientas',
        introPrefix: 'Cada herramienta en photremium.com — convertidor, compresor, redimensionador, eliminador de fondo, desenfoque facial, marca de agua, recorte y herramientas QR — procesa tus archivos',
        introStrong: '100% dentro de tu navegador web',
        introSuffix: 'usando JavaScript del lado del cliente y WebAssembly.',
        points: [
          { label: 'Nunca se suben archivos.', text: 'Cuando seleccionas un archivo, tu navegador lo lee con File API y lo procesa en memoria; nunca se envía por la red.' },
          { label: 'Ningún servidor recibe tu imagen.', text: 'Nuestro CDN solo entrega HTML, CSS y JavaScript para ejecutar la app, no tus archivos.' },
          { label: 'Sin almacenamiento temporal.', text: 'Los resultados existen solo en la memoria del navegador y se liberan al cerrar o salir de la página.' },
          { label: 'Funciona sin conexión.', text: 'La mayoría de herramientas sigue funcionando sin internet después de la carga inicial, prueba de que no interviene un servidor.' },
        ],
        callout: 'Puedes verificarlo: abre la pestaña Red (Network) en DevTools, selecciona una imagen y confirma que no se transmite ningún dato de archivo a servidores externos.',
      },
      dataCollect: {
        title: '3. Datos que recopilamos (y no recopilamos)',
        subtitle: 'Transparencia total sobre datos',
        headers: { type: 'Tipo de dato', collected: '¿Se recopila?', whereWhy: 'Dónde / por qué' },
        rows: [
          { type: 'Tus imágenes / archivos', badge: 'Nunca', variant: 'green', showX: true, whereWhy: 'Se procesan en tu navegador, nunca se transmiten' },
          { type: 'Nombre / correo electrónico', badge: 'Nunca', variant: 'green', showX: true, whereWhy: 'No se requiere cuenta ni registro para usar herramientas' },
          { type: 'Dirección IP', badge: 'Mínimo', variant: 'gray', showX: false, whereWhy: 'Registros web estándar retenidos <= 30 días, sin vínculo con identidad' },
          { type: 'Navegador / sistema operativo', badge: 'Mínimo', variant: 'gray', showX: false, whereWhy: 'Lo envía tu navegador automáticamente; solo para compatibilidad' },
          { type: 'Páginas visitadas / clics', badge: 'Agregado', variant: 'blue', showX: false, whereWhy: 'Solo analítica anónima (sin identificación personal)' },
          { type: 'Preferencia de idioma', badge: 'Solo local', variant: 'blue', showX: false, whereWhy: 'Guardado en localStorage en tu dispositivo; nunca se envía' },
          { type: 'Datos de pago / financieros', badge: 'Nunca', variant: 'green', showX: true, whereWhy: 'photremium.com es totalmente gratis, sin pagos' },
        ],
      },
      cookies: {
        title: '4. Cookies y almacenamiento local',
        subtitle: 'Qué se guarda en tu dispositivo',
        intro: 'photremium.com no usa cookies publicitarias, ni cookies de rastreo entre sitios, ni cookies de terceros. El almacenamiento del navegador se usa solo para funciones esenciales del sitio.',
        points: [
          { label: 'Preferencia de idioma', text: 'Se guarda en localStorage para recordar tu idioma entre visitas. Nunca se envía a nuestros servidores.' },
          { label: 'Tema / preferencias de interfaz', text: 'Si defines una preferencia visual, se guarda solo en tu dispositivo.' },
          { label: 'Sin cookies de sesión.', text: 'photremium.com no tiene sistema de inicio de sesión, por lo tanto no se escriben cookies de sesión.' },
        ],
        callout: 'Puedes borrar el almacenamiento local de photremium.com en cualquier momento desde la configuración del navegador (Ajustes -> Privacidad -> Borrar datos de navegación -> caché y cookies). Esto no afecta tu capacidad para usar las herramientas.',
      },
      thirdParty: {
        title: '5. Servicios de terceros',
        subtitle: 'Qué servicios externos usamos y por qué',
        intro: 'photremium.com usa un conjunto mínimo de servicios de terceros confiables solo para infraestructura y rendimiento. Ninguno recibe tus imágenes ni datos personales identificables.',
        headers: { service: 'Servicio', purpose: 'Propósito', dataShared: 'Datos compartidos', privacyPolicy: 'Política de privacidad' },
        rows: [
          { service: 'Cloudflare Pages', purpose: 'Hosting y entrega CDN de recursos del sitio', dataShared: 'Dirección IP, cabeceras HTTP (estándar)', privacyLink: 'https://www.cloudflare.com/privacypolicy/', privacyText: 'cloudflare.com/privacypolicy' },
          { service: 'Font Awesome', purpose: 'Iconos cargados desde CDN', dataShared: 'Dirección IP (solo solicitud CSS)', privacyLink: 'https://fontawesome.com/privacy', privacyText: 'fontawesome.com/privacy' },
          { service: 'Google Fonts', purpose: 'Carga de tipografías (si aplica)', dataShared: 'Dirección IP (solo solicitud de fuente)', privacyLink: 'https://policies.google.com/privacy', privacyText: 'policies.google.com' },
        ],
        outro: 'No compartimos tus datos con anunciantes, brokers de datos ni terceros fuera de los proveedores de infraestructura listados arriba.',
      },
      analytics: {
        title: '6. Analítica',
        subtitle: 'Datos agregados que respetan la privacidad',
        introPrefix: 'Para entender qué herramientas son más usadas y cómo mejorar el sitio, podemos recopilar',
        introStrong: 'estadísticas agregadas y anonimizadas',
        introSuffix: 'como:',
        points: [
          'Número de vistas por herramienta (sin identificación de usuario)',
          'Fuente de referencia (por ejemplo, búsqueda en Google o enlace directo), sin datos personales',
          'Datos geográficos por país (no ciudad ni ubicación exacta)',
          'Tipo de navegador / dispositivo para análisis de compatibilidad',
        ],
        calloutLabel: 'Ningún dato se vincula contigo personalmente.',
        calloutText: 'No usamos Google Analytics ni Meta Pixel. Si usamos analítica, es con herramientas centradas en privacidad (por ejemplo, Plausible o similares).',
      },
      children: {
        title: '7. Privacidad de menores',
        subtitle: 'Cumplimiento de seguridad infantil',
        p1: 'photremium.com no recopila conscientemente información personal de menores de 13 años (o 16 en la Unión Europea bajo GDPR). Como no recopilamos datos personales de ningún usuario, el sitio es igualmente seguro para todos.',
        p2Prefix: 'Si crees que un menor envió información personal mediante nuestro formulario de contacto, contáctanos de inmediato en',
        p2Suffix: 'y la eliminaremos rápidamente.',
      },
      rights: {
        title: '8. Tus derechos',
        subtitle: 'Derechos globales de privacidad',
        intro: 'Como photremium.com no recopila información personal identificable, la mayoría de derechos de protección de datos aplican de forma trivial: no hay datos tuyos que acceder, corregir o borrar. Aun así, respetamos plenamente los siguientes derechos:',
        points: [
          { label: 'Derecho de acceso', text: 'Puedes solicitar una copia de cualquier dato que tengamos sobre ti. (No hay ninguno más allá de registros anonimizados.)' },
          { label: 'Derecho de rectificación', text: 'Puedes solicitar la corrección de datos personales inexactos.' },
          { label: 'Derecho de supresión ("derecho al olvido")', text: 'Puedes solicitar la eliminación de cualquier dato personal que tengamos (GDPR Art. 17, CCPA).' },
          { label: 'Derecho de oposición / exclusión', text: 'Puedes excluirte de futuras analíticas usando opciones de exclusión del navegador o bloqueadores.' },
          { label: 'Derecho a la portabilidad', text: 'Todo tu trabajo se descarga directamente en tu dispositivo; no hace falta solicitar exportación.' },
        ],
        callout: 'Estos derechos se aplican a usuarios de todo el mundo sin importar jurisdicción; usamos el estándar más alto (GDPR) como base.',
      },
      security: {
        title: '9. Seguridad',
        subtitle: 'Cómo protegemos tu experiencia',
        intro: 'El dato más seguro es el que nunca se recopila. La arquitectura del lado del cliente de photremium.com evita que una brecha de servidor exponga tus archivos, porque nunca están en nuestros servidores. Medidas adicionales:',
        points: [
          { label: 'Aplicación de HTTPS', text: 'Todo el tráfico entre tu navegador y nuestro CDN se cifra con TLS 1.2+ y HSTS.' },
          { label: 'Política de Seguridad de Contenidos (CSP)', text: 'Cabeceras estrictas para prevenir XSS e inyección de scripts en línea.' },
          { label: 'Auditorías periódicas de dependencias', text: 'Auditamos y actualizamos paquetes npm regularmente para corregir vulnerabilidades conocidas.' },
        ],
        disclosurePrefix: 'Divulgación responsable',
        disclosureTextPrefix: '¿Encontraste un problema de seguridad? Escríbenos a',
        disclosureTextSuffix: 'y responderemos en 48 horas.',
      },
      changes: {
        title: '10. Cambios en esta política',
        subtitle: 'Cómo gestionamos las actualizaciones',
        intro: 'Podemos actualizar esta Política de Privacidad ocasionalmente para reflejar cambios en nuestras prácticas, herramientas o requisitos legales. Cuando lo hagamos:',
        points: [
          { label: '"Última actualización"', text: 'la fecha al inicio de esta página será revisada.' },
          { label: 'Cambios materiales', text: 'se comunicarán con un aviso visible en la página principal durante al menos 30 días.' },
          { label: 'Versiones anteriores', text: 'de esta política se archivarán y estarán disponibles bajo solicitud.' },
        ],
        outro: 'El uso continuado de photremium.com tras publicar cambios constituye aceptación de la política actualizada. Te recomendamos revisar esta página periódicamente.',
      },
      contact: {
        title: '11. Contacto y solicitudes de datos',
        subtitle: 'Escríbenos sobre privacidad',
        p1Prefix: 'Para cualquier pregunta, inquietud o solicitud formal de datos relacionada con esta Política de Privacidad, contáctanos. Nuestro objetivo es responder dentro de',
        p1Strong: '5 días hábiles',
      },
    },
    footer: {
      privacyQuestionsTitle: '¿Preguntas de privacidad?',
      privacyQuestionsDesc: 'Envíanos tus preguntas o solicitudes de datos y responderemos rápidamente.',
      versionHistoryTitle: 'Historial de versiones',
      v2Label: 'v2.0 — Reescritura mayor',
      v11Label: 'v1.1 — Se añadieron derechos CCPA',
      v10Label: 'v1.0 — Política inicial',
    },
  },

  common: {
    new: '¡Nuevo!',
    download: 'Descargar',
    downloadAll: 'Descargar Todo',
    upload: 'Subir',
    dragDrop: 'Arrastra y suelta imágenes aquí, o haz clic para explorar',
    remove: 'Eliminar',
    reset: 'Restablecer',
    apply: 'Aplicar',
    cancel: 'Cancelar',
    clear: 'Limpiar',
    close: 'Cerrar',
    save: 'Guardar',
    processing: 'Procesando...',
    noFiles: 'No hay archivos seleccionados',
    selectFiles: 'Seleccionar archivos',
    or: 'o',
    browseFiles: 'Explorar archivos',
    dropHere: 'Suelta los archivos aquí',
    quality: 'Calidad',
    width: 'Ancho',
    height: 'Altura',
    format: 'Formato',
    compression: 'Compresión',
    preview: 'Vista previa',
    original: 'Original',
    result: 'Resultado',
    before: 'Antes',
    after: 'Después',
    downloadAs: 'Descargar como:',
    zip: 'ZIP',
    separate: 'Separado',
    chooseFiles: 'Elegir archivos',
    pasteHint: 'También puedes pegar imágenes con',
    startOver: 'Empezar de nuevo',
    startOverConfirm: '¿Eliminar todas las imágenes y empezar de nuevo?',
    addMoreImages: 'Agregar más imágenes',
    addImage: 'Agregar imagen',
    images: 'Imágenes',
    totalSize: 'Tamaño total',
    size: 'Tamaño',
    type: 'Tipo',
    unsavedEdits: 'Tienes ediciones sin guardar. ¿Salir de la página?',
    compareSlider: 'Comparar deslizador',
    toggleToolsPanel: 'Alternar panel de herramientas',
    closePanel: 'Cerrar panel',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    fit: 'Ajustar',
    none: 'Ninguno',
  },

  compressor: {
    seo: {
      uploadTitle: 'Compresor de Imágenes — Comprimir JPG, PNG, SVG, GIF gratis | photremium.com',
      uploadDesc: 'Comprime imágenes JPG, PNG, SVG y GIF en línea de forma gratuita. Archivos hasta 80% más pequeños.',
      uploadKeywords: 'compresor de imágenes, comprimir jpg, comprimir png, reducir tamaño de imagen',
      workspaceTitle: 'Comprimir Imágenes — photremium.com Compresor de Imágenes',
      workspaceDesc: 'Ajusta el nivel de compresión y descarga imágenes optimizadas.',
      workspaceKeywords: 'comprimir imágenes, compresión de imágenes',
    },
    title: 'Compresor de Imágenes',
    desc: 'Comprime imágenes JPG, PNG y GIF hasta un 80% más pequeñas. Rápido y privado.',
    toCompress: 'para comprimir',
    compressionForAll: 'Compresión para todas las imágenes',
    summary: 'Resumen',
    originalSize: 'Tamaño original',
    compressed: 'Comprimido',
    saved: 'Ahorrado',
    compressionLabel: 'Compresión:',
    compressing: 'Comprimiendo…',
    compressDownload: 'Comprimir y Descargar',
    lowQualityWarning: 'Una compresión alta puede reducir notablemente la claridad de la imagen.',
    blog: {
      tocTitle: 'Contenido',
      title: 'Blog del Compresor de Imágenes',
      formatsIntro: 'Nuestra herramienta admite todos los formatos de imagen. Así, puedes comprimir cualquier imagen sin complicaciones. La lista de todos los formatos se muestra a continuación:',
      sections: [
        {
          id: 'imgcomp-card-1',
          title: '1. ¿Qué es un compresor de imágenes?',
          paragraphs: [
            'Un compresor de imágenes es una herramienta o servicio en línea que reduce el tamaño del archivo de una imagen manteniendo su calidad visual. Sin embargo, si se comprime demasiado, la pérdida de calidad puede hacerse visible.',
          ],
          listTitle: 'TIPOS:',
          bullets: [
            'Compresión con pérdida: en este tipo de compresión, el tamaño de la imagen se reduce eliminando parte de los datos. Puede disminuir la calidad, aunque normalmente el cambio no es perceptible a simple vista.',
            'Compresión sin pérdida: reduce el tamaño del archivo sin afectar la calidad visual de la imagen.',
          ],
        },
        {
          id: 'imgcomp-card-2',
          title: '2. ¿Por qué elegir nuestra herramienta?',
          bullets: [
            'Nuestra herramienta de compresión con IA funciona sin problemas en todos los dispositivos para ofrecerte los mejores resultados posibles.',
            'Puedes comprimir varias imágenes (incluso más de 100) a la vez con un solo clic.',
            'No necesitas subir tus imágenes a nuestros servidores. Todo se procesa en tu navegador local.',
            'Nuestro compresor de imágenes es totalmente gratuito para siempre. También puedes compartir esta herramienta con tus amigos.',
            'Puedes elegir el porcentaje de compresión según tu preferencia.',
          ],
        },
        {
          id: 'imgcomp-card-3',
          title: '3. Guía paso a paso',
          steps: [
            {
              heading: '1. Selecciona la(s) imagen(es) que quieres comprimir.',
              bullets: [
                'Arrastra y suelta la(s) imagen(es) en el cuadro de carga.',
                'También puedes copiar y pegar la(s) imagen(es) en el cuadro con (Ctrl + V).',
                'También puedes usar el explorador de archivos haciendo clic en el botón de elegir.',
              ],
            },
            {
              heading: '2. Luego selecciona el porcentaje de compresión.',
              bullets: [
                'Una barra deslizante horizontal te ofrece una experiencia cómoda para elegir el porcentaje de compresión. Sigue estos rangos para obtener resultados precisos.',
              ],
              table: {
                headers: ['Porcentaje de compresión', 'Resultados'],
                rows: [
                  ['1%  a  40%', 'Mejor calidad'],
                  ['41%  a  60%', 'Calidad normal (recomendado)'],
                  ['61%  a  100%', 'Mala calidad'],
                ],
              },
            },
            {
              heading: '3. Revisa la memoria que ahorraste.',
              paragraphs: [
                'Todas las métricas de memoria se muestran en tiempo real. Puedes ver claramente cuánto espacio ahorraste del total y ajustar el nivel de compresión según tu necesidad.',
              ],
            },
            {
              heading: '4. Selecciona la opción de descarga desde el botón de alternancia.',
              bullets: [
                'ZIP: si estás comprimiendo varias imágenes, verás esta opción. Al seleccionarla, todas las imágenes comprimidas se guardarán en un archivo ZIP (recomendado para muchas imágenes).',
                'Separado: esta opción descargará todas tus imágenes por separado y no en un único ZIP (recomendado para una cantidad pequeña, menos de 10).',
              ],
            },
            {
              heading: '5. Comprime y descarga la imagen.',
              paragraphs: [
                'Este botón descargará automáticamente todas las imágenes comprimidas según la opción de descarga seleccionada.',
              ],
            },
          ],
        },
        {
          id: 'imgcomp-card-4',
          title: '4. Beneficios del compresor de imágenes.',
          bullets: [
            'Reduce el costo de almacenamiento: al comprimir imágenes, su tamaño disminuye y necesitas menos espacio.',
            'Carga más rápida: las imágenes comprimidas cargan más rápido y mejoran la experiencia del usuario en sitios web y apps.',
            'Solución al límite de Gmail: Gmail permite adjuntar solo hasta 25 MB. Comprimir imágenes te ayuda a enviar más archivos.',
            'Compartir y transferir más rápido: los archivos grandes tardan más en transferirse. La compresión ahorra tiempo y datos, y evita límites de algunas plataformas.',
            'Optimización de presentaciones: una presentación con imágenes sin comprimir puede pesar mucho y volverse lenta; comprimidas, pesa mucho menos y es más fácil subirla a portales académicos o laborales.',
          ],
        },
        {
          id: 'imgcomp-card-5',
          title: '5. Formatos compatibles.',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  converter: {
    seo: {
      uploadTitle: 'Convertidor de Imágenes — Convertir PNG, JPG, WEBP, GIF, SVG gratis | photremium.com',
      uploadDesc: 'Convierte imágenes entre JPG, PNG, WEBP, GIF, SVG, TIFF, BMP. Gratis y privado.',
      uploadKeywords: 'convertidor de imágenes, png a jpg, jpg a png, convertidor webp',
      workspaceKeywords: 'convertir imágenes, convertidor de formato',

      routeKeywords: {

        'png-to-jpg': 'png para convertir jpg, png to jpg, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'jpg-to-png': 'jpg para convertir png, jpg to png, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'png-to-webp': 'png para convertir webp, png to webp, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'jpg-to-webp': 'jpg para convertir webp, jpg to webp, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'webp-to-jpg': 'webp para convertir jpg, webp to jpg, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'webp-to-png': 'webp para convertir png, webp to png, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'gif-to-jpg': 'gif para convertir jpg, gif to jpg, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'gif-to-png': 'gif para convertir png, gif to png, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'bmp-to-jpg': 'bmp para convertir jpg, bmp to jpg, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'bmp-to-png': 'bmp para convertir png, bmp to png, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'svg-to-png': 'svg para convertir png, svg to png, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'svg-to-jpg': 'svg para convertir jpg, svg to jpg, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'tiff-to-jpg': 'tiff para convertir jpg, tiff to jpg, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'tiff-to-png': 'tiff para convertir png, tiff to png, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'jpg-to-gif': 'jpg para convertir gif, jpg to gif, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'png-to-gif': 'png para convertir gif, png to gif, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'jpg-to-bmp': 'jpg para convertir bmp, jpg to bmp, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'png-to-bmp': 'png para convertir bmp, png to bmp, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'webp-to-gif': 'webp para convertir gif, webp to gif, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'jpg-to-ico': 'jpg para convertir ico, jpg to ico, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'png-to-ico': 'png para convertir ico, png to ico, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'jpg-to-svg': 'jpg para convertir svg, jpg to svg, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'png-to-svg': 'png para convertir svg, png to svg, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'webp-to-svg': 'webp para convertir svg, webp to svg, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'gif-to-svg': 'gif para convertir svg, gif to svg, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'bmp-to-svg': 'bmp para convertir svg, bmp to svg, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

        'tiff-to-svg': 'tiff para convertir svg, tiff to svg, convertidor de imágenes, png a jpg, jpg a png, convertidor webp',

      },
    },
    title: 'Convertidor de Imágenes',
    desc: 'Convierte imágenes entre JPG, PNG, WEBP, GIF, SVG, TIFF, BMP y más.',
    toConvert: 'para convertir',
    convertSettings: 'Configuración de conversión',
    detected: 'Detectado',
    convertTo: 'Convertir a',
    converting: 'Convirtiendo…',
    convertToFormat: 'Convertir a {format}',
    popularConversions: 'Conversiones populares',
    convertingTo: 'Convirtiendo a',
    all: 'Todo',
  },

  resizer: {
    seo: {
      uploadTitle: 'Redimensionar Imagen — Escalar JPG, PNG gratis | photremium.com',
      uploadDesc: 'Redimensiona imágenes en línea gratis por píxeles o porcentaje.',
      uploadKeywords: 'redimensionar imagen, cambiar tamaño de imagen',
      workspaceTitle: 'Redimensionar Imágenes — photremium.com',
      workspaceDesc: 'Cambia el tamaño de imágenes en línea gratis.',
      workspaceKeywords: 'redimensionar imagen',
    },
    title: 'Redimensionar Imagen',
    desc: 'Establece dimensiones en píxeles, porcentaje, centímetros o pulgadas y redimensiona imágenes al instante.',
    toResize: 'para redimensionar',
    resizeSettings: 'Configuración de redimensionado',
    resizeBy: 'Redimensionar por:',
    byPixels: 'Por píxeles',
    byPercentage: 'Por porcentaje',
    byCentimeters: 'Por centímetros',
    byInches: 'Por pulgadas',
    advanced: 'Avanzado',
    lockAspect: 'Bloquear relación de aspecto',
    unlockAspect: 'Desbloquear relación de aspecto',
    dontEnlarge: 'No ampliar si el original es más pequeño',
    resizing: 'Redimensionando…',
    resizeDownload: 'Redimensionar y Descargar',
    blog: {
      tocTitle: 'Contenido',
      title: 'Blog del Redimensionador de Imágenes',
      sections: [
        {
          id: 'imgresize-card-1',
          title: '1. ¿Por qué usar un redimensionador de imágenes?',
          paragraphs: [
            'Un redimensionador de imágenes es una herramienta o software que se usa para cambiar las dimensiones de una imagen. Te permite ajustar el tamaño de la imagen deseada cambiando su alto, su ancho o ambos. Esta herramienta es especialmente útil para plataformas de redes sociales que tienen restricciones de tamaño al subir o publicar imágenes.',
          ],
          listTitle: 'Por ejemplo:',
          bullets: [
            'Publicaciones de Instagram: 1080 x 1080px (cuadrado)',
            'Publicación de Facebook: 1200 x 630px',
            'Publicación de X (antes Twitter): 1200 x 675px',
            'Historia de Instagram: 1080 x 1920px',
          ],
        },
        {
          id: 'imgresize-card-2',
          title: '2. ¿Por qué elegir nuestra herramienta de redimensionado de imágenes?',
          paragraphs: [
            'Nuestro redimensionador de imágenes con IA hace que el proceso sea preciso y extremadamente rápido. Puedes usar esta herramienta en cualquier dispositivo sin problemas. No necesitas instalar ni descargar ninguna app. Todos los servicios están disponibles en línea en el navegador que prefieras.',
          ],
          bullets: [
            'Puedes redimensionar varias imágenes (incluso 100+) a la vez con nuestra herramienta. Si tienes un dispositivo de alto rendimiento, puedes redimensionar cómodamente de 400 a 500 imágenes en segundos.',
            'Todo el procesamiento se hace en tu navegador local. No tienes que subir ninguna imagen a nuestros servidores. Tus imágenes nunca salen de tu dispositivo. Así, puedes redimensionar imágenes personales sin riesgos de privacidad.',
            'Se admiten múltiples unidades para redimensionar imágenes.',
            'También puedes mantener la relación de aspecto original incluso después de redimensionar, solo marcando la casilla.',
            'Si redimensionas varias imágenes, puedes descargar los resultados por separado o como archivo ZIP.',
          ],
        },
        {
          id: 'imgresize-card-3',
          title: '3. Guía paso a paso',
          steps: [
            {
              heading: 'Primero, selecciona la imagen o varias imágenes que deseas redimensionar. Tienes varias formas de seleccionarlas.',
              bullets: [
                'Puedes arrastrar y soltar las imágenes para redimensionarlas.',
                'También se admite el atajo “Ctrl + V” para pegar la imagen en el recuadro.',
                'Al hacer clic en “Choose Files” se abrirá el explorador de archivos. También puedes seleccionar allí las imágenes deseadas.',
              ],
            },
            {
              heading: 'Luego, puedes elegir una de las unidades para redimensionar la imagen. Actualmente ofrecemos estas unidades:',
              bullets: ['Pixels', 'Percentage', 'Centimeters', 'Inches'],
            },
            {
              heading: 'Después de elegir la unidad, ajusta alto y ancho para redimensionar la imagen. También puedes bloquear la relación de aspecto marcando la casilla.',
            },
            {
              heading: 'Después marca “Don’t enlarge if original is smaller” si no quieres que la imagen resultante se amplíe por encima de su tamaño original.',
            },
            {
              heading: 'Después, selecciona la opción de descarga.',
              bullets: [
                'Selecciona ZIP si quieres redimensionar varias imágenes y descargarlas todas como un archivo zip.',
                'O selecciona “separate” para descargar cada imagen redimensionada por separado.',
              ],
            },
            {
              heading: 'Luego pulsa el botón “Resize & Download” para descargar tus imágenes redimensionadas según la opción elegida.',
            },
          ],
        },
        {
          id: 'imgresize-card-4',
          title: '4. Beneficios de la herramienta de redimensionado: El beneficio más notable de esta herramienta es la correcta colocación de imágenes dentro de páginas web y publicaciones en redes sociales.',
          tocLabel: '4. Beneficios de la herramienta de redimensionado',
          bullets: [
            'Mejora de UX: El tamaño correcto y la colocación adecuada de imágenes mejoran mucho la experiencia de usuario. Colocar imágenes demasiado grandes o demasiado pequeñas sin ajuste genera mala experiencia.',
            'Compatibilidad con redes sociales: Varias aplicaciones sociales tienen límites de dimensiones para publicar imágenes. Nuestra herramienta te ayuda a ajustar tus imágenes a esas dimensiones requeridas.',
            'Diseño responsive: Si eres desarrollador y quieres crear un diseño responsive, debes redimensionar imágenes en múltiples dimensiones para soportar múltiples dispositivos.',
            'Mejor opción: En lugar de estirar o recortar imágenes, lo cual puede alterar sus dimensiones, redimensionar es la mejor opción.',
          ],
        },
        {
          id: 'imgresize-card-5',
          title: '5. Formatos compatibles: Nuestra herramienta de redimensionado permite seleccionar imágenes de cualquier formato para cambiar su tamaño. Estos son los formatos:',
          tocLabel: '5. Formatos compatibles',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  cropper: {
    seo: {
      uploadTitle: 'Recortar Imagen — Cortar JPG, PNG, GIF gratis | photremium.com',
      uploadDesc: 'Recorta imágenes JPG, PNG y GIF en línea fácilmente.',
      uploadKeywords: 'recortar imagen, cortar jpg, cortar png',
      workspaceTitle: 'Recortar Imágenes — photremium.com',
      workspaceDesc: 'Recorta imágenes en línea gratis.',
      workspaceKeywords: 'recortar imagen',
    },
    title: 'Recortar Imagen',
    desc: 'Recorta imágenes JPG, PNG, GIF y más con el editor visual.',
    toCrop: 'para recortar',
    cropSettings: 'Configuración de recorte',
    widthPx: 'Ancho (px)',
    heightPx: 'Alto (px)',
    positionX: 'Posición X (px)',
    positionY: 'Posición Y (px)',
    cropTemplate: 'Plantilla de recorte',
    landscape: 'Paisaje',
    portrait: 'Retrato',
    square: 'Cuadrado',
    freeform: 'Libre',
    cropping: 'Recortando…',
    cropDownload: 'Recortar y Descargar',
    cropDownloadAll: 'Recortar todas y descargar',
    saveNext: 'Guardar y Siguiente',
    croppedNofTotal: 'Has recortado {n} de {total} imágenes.',
    downloadN: 'Descargar {n}',
    blog: {
      tocTitle: 'Contenido',
      title: 'Blog del Recortador de Imágenes',
      sections: [
        {
          id: 'imgcrop-card-1',
          title: '1. ¿Por qué usar un recortador de imágenes?',
          paragraphs: [
            'El recortador de imágenes es una herramienta de software que se utiliza para cortar la imagen con la forma deseada. Se usa ampliamente para cortar una parte necesaria de la imagen y eliminar la parte exterior no deseada para cualquier propósito. Proporciona un cuadro de recorte que puedes ajustar en la posición en la que deseas recortar.',
          ],
          listTitle: 'Por ejemplo:',
          bullets: [
            'Recortar tu propia imagen de una foto grupal.',
            'Recortar tu nombre de una lista.',
            'Recortar la barra de progreso de una captura de pantalla completa.',
          ],
        },
        {
          id: 'imgcrop-card-2',
          title: '2. ¿Por qué elegir nuestro recortador de imágenes?',
          paragraphs: [
            'Nuestra herramienta de recorte de imágenes te permite recortar imágenes con precisión y muy rápido. Solo tienes que ajustar el tamaño del cuadro de recorte en la posición que quieras cortar de cualquier imagen. Casi todos los formatos de imagen son compatibles para seleccionar la imagen.',
          ],
          bullets: [
            'Puedes recortar tantas imágenes como tu dispositivo soporte. Si tienes un dispositivo de alto rendimiento, puedes recortar incluso más de 100 imágenes a la vez sin retrasos ni otros problemas.',
            'Tus imágenes se procesarán en tu navegador local. No es necesario subir ninguna imagen a nuestros servidores, por lo que ninguna imagen sale de tu dispositivo. Puedes recortar tus imágenes personales sin inseguridad ni riesgo.',
            'Muchas herramientas muestran error de formato de imagen no válido. Nuestra herramienta de recorte de imágenes se encarga de este problema al admitir casi todos los formatos de imagen.',
            'Si recortas varias imágenes a la vez, nuestra herramienta te permite descargar las imágenes recortadas como ZIP o como imágenes separadas según tu preferencia.',
          ],
        },
        {
          id: 'imgcrop-card-3',
          title: '3. Guía paso a paso',
          steps: [
            {
              heading: '1. Antes que nada, selecciona la imagen que deseas recortar. Nuestro recortador de imágenes también admite seleccionar múltiples imágenes a la vez.',
              bullets: [
                'Arrastra y suelta la imagen en el cuadro para recortarla.',
                'También puedes seleccionar la imagen mediante el explorador de archivos haciendo clic en el botón elegir archivos colocado en el cuadro de recorte.',
                'También se admite el atajo Ctrl + V para pegar las imágenes en el cuadro.',
              ],
            },
            {
              heading: '2. Luego, ajusta el tamaño y la posición del cuadro de recorte sobre la imagen para cortarla.',
            },
            {
              heading: '3. También puedes ajustar el cuadro de recorte introduciendo manualmente los valores de altura, ancho, posición horizontal y posición vertical.',
            },
            {
              heading: '4. También puedes usar algunas plantillas prefabricadas:',
              bullets: [
                'Paisaje(16:9)',
                'Retrato(9:16)',
                'Cuadrado(1:1)',
              ],
            },
            {
              heading: '5. Luego tienes que seleccionar una de las opciones de descarga.',
              bullets: [
                'ZIP: Selecciona esta opción si estás recortando múltiples imágenes y deseas descargar todas las imágenes recortadas como un solo archivo.',
                'Separadas: Si deseas descargar todas las imágenes recortadas por separado, selecciona esta opción desde el botón de alternancia.',
              ],
            },
            {
              heading: '6. Luego haz clic en el botón Recortar y Descargar para descargar todas tus imágenes recortadas según tus dimensiones preestablecidas.',
            },
          ],
        },
        {
          id: 'imgcrop-card-4',
          title: '4. Beneficios del Recortador de Imágenes: La herramienta de recorte de imágenes ofrece varios beneficios en el mundo digital. Algunos se describen a continuación:',
          tocLabel: '4. Beneficios del Recortador de Imágenes',
          bullets: [
            'Ajuste de imágenes en marcos: El recortador de imágenes te ayuda a ajustar las imágenes correctamente en marcos. Estos marcos pueden estar en una página web o en cualquier plataforma de redes sociales.',
            'Mejora de UX: Como la correcta colocación de imágenes mejora la experiencia de usuario, el recortador de imágenes ayuda a mejorar la UX en gran medida.',
            'Eliminación de bordes no deseados: Puedes eliminar cualquier borde no deseado de una imagen para refinarla.',
            'Separación del objeto deseado: También puedes separar tu imagen de una foto grupal.',
            'Ahorro de almacenamiento: Recortar la imagen definitivamente ahorra almacenamiento, ya que se corta el área bruta de la imagen y solo se guarda la parte deseada.',
            'Optimización de presentaciones: Como una presentación normal con 10 imágenes sin recortar ocupa casi 30MB de almacenamiento, la misma presentación con imágenes recortadas puede ocupar casi 10MB.',
          ],
        },
        {
          id: 'imgcrop-card-5',
          title: '5. Formatos compatibles:',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  photoEditor: {
    seo: {
      title: 'Editor de Fotos — Editar fotos gratis en línea | photremium.com',
      desc: 'Edita fotos en línea gratis — agrega texto, efectos, marcos y más.',
      keywords: 'editor de fotos, editar fotos en línea',
    },
    title: 'Editor de Fotos',
    desc: 'Agrega texto, efectos, marcos y pegatinas a las imágenes.',
    toEdit: 'para editar',
    textTypography: 'Texto y Tipografía',
    textTypographyDesc: 'Agrega texto personalizado con diferentes fuentes, colores y sombras.',
    filtersEffects: 'Filtros y Efectos',
    filtersEffectsDesc: 'Aplica filtros profesionales, ajusta brillo, contraste y saturación.',
    framesStickers: 'Marcos y Pegatinas',
    framesStickersDesc: 'Elige marcos hermosos y pegatinas divertidas para mejorar las imágenes.',
  },

  removeBg: {
    seo: {
      uploadTitle: 'Eliminar Fondo de Imagen gratis | photremium.com',
      uploadDesc: 'Elimina fondos de imágenes de forma rápida y precisa. Gratis.',
      uploadKeywords: 'eliminar fondo, quitar fondo de imagen, fondo transparente',
      workspaceTitle: 'Eliminar Fondos — photremium.com',
      workspaceDesc: 'Elimina fondos de imágenes gratis en línea.',
      workspaceKeywords: 'eliminar fondo',
    },
    title: 'Eliminar Fondo',
    desc: 'Elimina fondos de imágenes al instante. 100% gratis, funciona en tu navegador.',
    toRemoveBg: 'Eliminar fondo',
    backgroundRemover: 'Removedor de fondo',
    processingProgress: 'Progreso de procesamiento',
    processingNImages: 'Procesando {n} imagen(es)…',
    allNProcessed: '¡Todas las {n} imagen(es) procesadas!',
    nOfTotalDone: '{n} / {total} listo',
    fileName: 'Nombre de archivo',
    dimensions: 'Dimensiones',
    status: 'Estado',
    statusDone: '✓ Listo',
    statusProcessing: '⏳ Procesando',
    statusError: '✗ Error',
    statusPending: '⏸ Pendiente',
    badgeDone: 'Listo',
    badgeProcessing: 'Procesando…',
    badgeError: 'Error',
    removingBg: 'Eliminando fondo…',
    retry: 'Reintentar',
    downloading: 'Descargando…',
    nextImage: 'Siguiente imagen',
  },

  watermark: {
    seo: {
      uploadTitle: 'Agregar Marca de Agua en línea gratis | photremium.com',
      uploadDesc: 'Agrega marcas de agua de texto o imagen a las fotos. Gratis y rápido.',
      uploadKeywords: 'marca de agua, agregar marca de agua',
      workspaceTitle: 'Agregar Marca de Agua — photremium.com',
      workspaceDesc: 'Agrega marcas de agua gratis en línea.',
      workspaceKeywords: 'marca de agua',
    },
    title: 'Agregar Marca de Agua',
    desc: 'Agrega marcas de agua de texto o logotipo a las imágenes.',
    toWatermark: 'para marca de agua',
    watermarkTools: 'Herramientas de marca de agua',
    addText: 'Agregar texto',
    addImage: 'Agregar imagen',
    layersN: 'Capas ({n})',
    noLayers: 'Aún no se han agregado capas',
    textLayer: 'Capa de texto',
    imageLayer: 'Capa de imagen',
    watermarkDownloadAll: 'Marca de agua y Descargar todo',
    watermarkDownload: 'Marca de agua y Descargar',
    nextImage: 'Siguiente imagen',
    privateMode: 'Modo privado',
    privateModeOn: 'Modo privado ACTIVADO: solo mover y escalar marca de agua…',
    privateModeHint: 'Activa el modo privado para solo ajustar posición y tamaño…',
    privateModeActive: 'Modo privado — solo mover, escalar y tamaño de fuente permitido',
    selectToEdit: 'Selecciona una imagen o texto para comenzar a editar',
    bold: 'Negrita',
    italic: 'Cursiva',
    underline: 'Subrayado',
    bgColor: 'Color de fondo',
    textColor: 'Color de texto',
    alignLeft: 'Alinear a la izquierda',
    alignCenter: 'Centrar',
    alignRight: 'Alinear a la derecha',
    opacity: 'Opacidad',
    stroke: 'Contorno',
    strokeWidth: 'Grosor de contorno',
    strokeColor: 'Color de contorno',
    tileRepeat: 'Mosaico / Repetir',
    tilePattern: 'Patrón de mosaico',
    spacing: 'Espaciado',
    snapToCenter: 'Ajustar al centro',
    duplicate: 'Duplicar',
    delete: 'Eliminar',
    flipHorizontal: 'Voltear horizontal',
    flipVertical: 'Voltear vertical',
    rotateLeft: 'Rotar a la izquierda',
    rotateRight: 'Rotar a la derecha',
    cornerRadius: 'Radio de esquina',
    borderStroke: 'Borde / Contorno',
    borderWidth: 'Grosor de borde',
    color: 'Color',
    style: 'Estilo',
    hide: 'Ocultar',
    show: 'Mostrar',
    lock: 'Bloquear',
    unlock: 'Desbloquear',
    solid: 'Sólido',
    dashed: 'Discontinuo',
    dotted: 'Punteado',
    double: 'Doble',
    tileSingle: 'Individual',
    tile2x2: 'Cuadrícula 2×2',
    tile3x3: 'Cuadrícula 3×3',
    removeAllConfirm: '¿Eliminar todas las imágenes y marcas de agua?',
    dimMismatch: 'Las imágenes cargadas tienen dimensiones diferentes. Para mejores resultados, carga imágenes con la misma resolución.',
    clearBackground: 'Limpiar fondo',
    typeHere: 'Escribe aquí...',
    linkCorners: 'Vincular esquinas',
    separateCorners: 'Separar esquinas',
    blog: {
      tocTitle: 'Contenido',
      sections: [
        {
          id: 'wm-blog-intro',
          tocLabel: 'Resumen de la herramienta',
          title: 'Cómo añadir una marca de agua a tus imágenes online — La guía completa de la herramienta de marca de agua de Photremium',
          paragraphs: [
            'Acabas de terminar de editar una fotografía preciosa. Tal vez es una foto de producto para tu tienda, un retrato de una sesión con cliente o una pieza de arte digital en la que invertiste horas. Y ahora llega la pregunta que todo creador se hace tarde o temprano: ¿cómo la proteges antes de compartirla?',
            'La respuesta a la que llegan la mayoría de profesionales es: una marca de agua — y con razón. Una marca de agua bien colocada actúa como una firma permanente, hace tu trabajo rastreable y con marca, y dificulta mucho el robo.',
            'El problema con la mayoría de herramientas online es que son torpes, están detrás de suscripciones o ponen una marca tan pesada que arruina la imagen.',
            'La herramienta de marca de agua de Photremium se creó para resolver eso. Es un espacio de trabajo 100% en el navegador, gratuito y sin cuenta, que nunca sube tus archivos a un servidor. Todo queda local, todo es rápido, y el control creativo rivaliza con aplicaciones de escritorio. En esta guía te mostramos cómo funciona, para quién está hecho y cómo obtener los mejores resultados en cada uso.',
          ],
        },
        {
          id: 'wm-blog-what-is',
          tocLabel: 'Qué es una marca de agua',
          title: '¿Qué es una marca de agua y por qué importa?',
          paragraphs: [
            'Antes de entrar al funcionamiento de la herramienta, conviene entender qué hace una marca de agua y por qué tantos fotógrafos, diseñadores y creadores la consideran imprescindible.',
            'Una marca de agua es una superposición visible sobre una imagen — normalmente texto, un logotipo o un símbolo de copyright — que identifica al creador o propietario. A diferencia de los metadatos (que están ocultos en el archivo y pueden borrarse en segundos), la marca de agua está integrada visualmente en la imagen. No puedes quitarla con un clic sin degradar la calidad.',
          ],
          subSections: [
            {
              title: 'Por qué los creadores usan marcas de agua',
              paragraphs: [
                'Las razones prácticas para marcar tus imágenes se resumen en tres puntos clave.',
              ],
              bullets: [
                'Identificación de autoría. Cuando tu trabajo se comparte en redes sociales, tableros de Pinterest o artículos, la atribución original se pierde. La marca de agua asegura que tu nombre o marca viaje con la imagen.',
                'Disuasión de robo. La mayoría de quienes roban imágenes buscan la vía fácil. Una marca profesional, bien colocada y ligeramente transparente envía un mensaje claro: esta imagen pertenece a alguien que la protege.',
                'Protección de portafolios de clientes. Fotógrafos que envían previsualizaciones antes del pago usan marcas de agua para evitar uso indebido. Una marca sutil protege sin impedir la evaluación del trabajo.',
              ],
            },
            {
              title: 'Quién debería poner marcas de agua',
              paragraphs: [
                'Si perteneces a alguna de estas categorías, marcar tus imágenes antes de compartir no es opcional — es esencial:',
              ],
              bullets: [
                'Fotógrafos freelance que comparten galerías con clientes',
                'Diseñadores gráficos que publican muestras de portafolio',
                'Vendedores de e-commerce que muestran fotos de producto antes de licenciar',
                'Artistas digitales que publican en redes sociales',
                'Bloggers y creadores cuyas imágenes se reutilizan con frecuencia',
                'Contribuidores de stock que construyen una marca reconocible',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-workspace',
          tocLabel: 'Paneles del espacio de trabajo',
          title: 'Dentro de la herramienta de marca de agua de Photremium: un espacio de trabajo de tres paneles para flujos reales',
          paragraphs: [
            'Lo que diferencia a Photremium de los marcadores online básicos es su diseño de espacio de trabajo. En lugar de un flujo simple de “escribir texto, elegir posición, listo”, ofrece un layout de tres paneles similar al software profesional — pero en el navegador y sin instalación.',
          ],
          subSections: [
            {
              title: 'El panel de lienzo izquierdo',
              paragraphs: [
                'El panel del lienzo ocupa la mayor parte de la pantalla y muestra tu imagen con la marca aplicada en tiempo real. Cada ajuste — opacidad, posición del texto, tamaño del logo — se refleja al instante. No hay botón de “vista previa”. Lo que ves es lo que obtienes.',
                'El lienzo incluye una barra de zoom para alineación precisa. La función de zoom automático calcula la mejor escala inicial según tu pantalla, para que incluso imágenes de alta resolución se vean cómodas. Aparecen guías dinámicas cuando arrastras una capa cerca del centro, y la marca se ajusta con precisión al medio, como en Photoshop.',
              ],
            },
            {
              title: 'El panel de ajustes derecho',
              paragraphs: [
                'El panel derecho es el centro de control. Aquí gestionas capas, personalizas su apariencia y haces el export final. En escritorio queda fijo a la derecha. En móvil aparece como una hoja inferior que se abre con un botón flotante, sin cubrir el lienzo.',
                'En este panel está el administrador de capas, que lista cada elemento. Cada capa muestra tipo (texto o imagen), nombre o contenido, y tres acciones rápidas: visibilidad (icono de ojo), bloqueo de posición y eliminación.',
              ],
            },
            {
              title: 'La tira de previsualización izquierda (modo multiimagen)',
              paragraphs: [
                'Cuando trabajas con múltiples imágenes — por ejemplo fotos de producto o una sesión completa — aparece una tira vertical de miniaturas a la izquierda. Es la cola de imágenes. Al hacer clic en cualquier miniatura, el lienzo cambia instantáneamente a esa imagen sin perder tus capas.',
                'La tira también muestra tamaño en KB/MB y formato (JPG, PNG, WEBP) para tener claridad inmediata de lo que estás editando.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-steps',
          tocLabel: 'Paso a paso',
          title: 'Paso a paso: cómo añadir una marca de agua en Photremium',
          paragraphs: [
            'Este recorrido se basa en cómo funciona realmente la herramienta — desde el upload drag-and-drop hasta el render en canvas antes de descargar.',
          ],
          steps: [
            {
              heading: 'Paso 1 — Sube tu(s) imagen(es)',
              paragraphsBefore: [
                'Ve a photremium.com/watermark-image. Llegarás a la pantalla de subida con una zona de drop en el centro.',
                'Tienes tres formas de cargar imágenes:',
              ],
              bullets: [
                'Drag and drop. Arrastra uno o varios archivos a la zona. Se aceptan JPEG, PNG, WEBP y más. Al arrastrar, aparece un borde morado con el mensaje “Drop images to add for watermarking”.',
                'Click para explorar. Haz clic en “Choose Files” para abrir el selector. Puedes elegir múltiples archivos con Ctrl+Click (Windows) o Cmd+Click (Mac).',
                'Pegar desde el portapapeles. Si copiaste una imagen, presiona Ctrl+V (Cmd+V en Mac). Funciona incluso con varias imágenes ya cargadas.',
              ],
              paragraphsAfter: [
                'Cuando se carga la primera imagen, el espacio de trabajo cambia al editor de tres paneles y el lienzo muestra tu imagen con un zoom inicial automático.',
              ],
            },
            {
              heading: 'Paso 2 — Añadir una capa de texto',
              paragraphsBefore: [
                'Haz clic en el botón morado “Add Text” en el panel derecho. Aparece una nueva capa con el texto “Type here...”.',
                'Puedes escribir de inmediato. El texto se renderiza en vivo. En la barra superior puedes ajustar:',
              ],
              bullets: [
                'Font family — 12 fuentes integradas como Arial, Georgia, Impact, Brush Script MT, Comic Sans MS, etc.',
                'Font size — escribe un valor en px o usa los controles',
                'Bold, italic, underline — combinaciones de estilo',
                'Text color — selecciona cualquier color',
                'Background color — fondo de color para estilo badge',
                'Stroke (outline) — contorno para legibilidad en fondos claros/oscuros',
                'Opacity — de 0% a 100%; lo común es 30–60%',
                'Alignment — izquierda, centro o derecha',
                'Rotation — rotación libre con snaps a 0°, 90°, 180°, 270°',
              ],
              paragraphsAfter: [
                'Para mover el texto, arrástralo. Para precisión, usa las flechas (Shift para 10 px). Para redimensionar, arrastra cualquiera de los 8 handles.',
              ],
            },
            {
              heading: 'Paso 3 — Añadir una capa de imagen (logo)',
              paragraphsBefore: [
                'Si quieres usar un logo o firma, pulsa “Add Image” en el panel derecho y elige el archivo. La herramienta lo escala automáticamente a ~30% del ancho del lienzo y lo centra.',
                'Luego puedes moverlo, redimensionarlo desde las esquinas (con proporción fija) o rotarlo con el handle superior. Para capas de imagen hay controles adicionales:',
              ],
              bullets: [
                'Opacity — igual que en texto, ideal para logos PNG',
                'Flip horizontal / Flip vertical — espejo',
                'Border width, border color, border style — borde visible',
                'Border radius — esquinas redondeadas uniformes o por esquina',
                'Rotation — misma rotación suave que en texto',
              ],
            },
            {
              heading: 'Paso 4 — Configurar el mosaico (opcional)',
              paragraphsBefore: [
                'Una función potente es el mosaico — repetir el watermark en una grilla sobre toda la imagen. Es útil si quieres evitar reutilización no autorizada.',
                'Con una capa seleccionada, elige Tile:',
              ],
              bullets: [
                'None — una sola colocación (por defecto)',
                'Grid 2×2 — repite en patrón 2x2',
                'Grid 3×3 — repite en patrón 3x3',
              ],
              paragraphsAfter: [
                'También puedes ajustar el spacing para controlar la distancia entre repeticiones. El lienzo muestra copias fantasma para previsualización.',
              ],
            },
            {
              heading: 'Paso 5 — Usar el gestor de capas',
              paragraphsBefore: [
                'Puedes añadir tantas capas como quieras. El gestor las lista todas. Puedes:',
              ],
              bullets: [
                'Mostrar/ocultar capas con el icono de ojo',
                'Bloquear una capa para evitar movimientos accidentales',
                'Eliminar una capa',
              ],
              paragraphsAfter: [
                'Al hacer clic en una capa, se selecciona en el lienzo para editarla rápidamente.',
              ],
            },
            {
              heading: 'Paso 6 — Cambiar entre varias imágenes',
              paragraphsBefore: [
                'Si subiste más de una imagen, usa la tira de miniaturas para cambiar de imagen activa. Tus capas se aplican a todas al exportar.',
                'La herramienta comprueba la consistencia de resolución. Si hay diferencias mayores al 5%, verás un aviso. La posición se recalcula proporcionalmente para mantener el aspecto coherente.',
              ],
            },
            {
              heading: 'Paso 7 — Configurar preferencias de descarga',
              paragraphsBefore: [
                'Para una sola imagen, pulsa “Download” debajo del lienzo. El nombre se guarda con “-watermarked”. JPEG se exporta a 0.95 de calidad; PNG es lossless.',
                'Para lotes, tienes dos modos en el panel derecho:',
              ],
              bullets: [
                'ZIP — todas las imágenes en un solo ZIP',
                'Separate — cada imagen se descarga por separado con pequeñas pausas',
              ],
            },
            {
              heading: 'Paso 8 — Descargar y verificar',
              paragraphsBefore: [
                'Al descargar, la herramienta renderiza cada imagen en un canvas oculto a resolución completa — no a la escala del preview. Esto garantiza tamaño original con marca de agua bien proporcional. Abre el archivo y haz zoom para comprobar calidad y posición.',
                'Si algo no queda bien, vuelve al espacio de trabajo, ajusta y descarga de nuevo.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-tips',
          tocLabel: 'Consejos pro',
          title: 'Consejos pro para mejores resultados',
          bullets: [
            'Usa un logo PNG semitransparente para un acabado profesional. Un logo con 40–50% de opacidad se ve mejor que texto sólido.',
            'Coloca el watermark donde recortar afecte el valor. La esquina inferior derecha es la más común — y la más fácil de recortar. Para mayor protección, colócalo sobre un área importante. El mosaico diagonal es aún más difícil de quitar.',
            'Usa el bloqueo al trabajar con varias capas. Una vez fijada la posición principal, bloquea la capa antes de añadir otras.',
            'Prueba en áreas claras y oscuras. Un watermark blanco se pierde en cielo claro pero es legible en sombras. Añade contorno o fondo sutil para legibilidad.',
            'Los atajos ahorran tiempo. Flechas mueven 1 px; Shift+Arrow mueve 10 px. Delete elimina el layer al instante.',
          ],
        },
        {
          id: 'wm-blog-privacy',
          tocLabel: 'Privacidad y seguridad',
          title: 'Privacidad y seguridad: por qué importa el procesamiento en el navegador',
          paragraphs: [
            'Una preocupación común con herramientas online es a dónde van las imágenes. En herramientas basadas en servidor, la imagen se sube, se procesa y se devuelve. Eso implica que trabajos inéditos pasan por infraestructura de terceros.',
            'La herramienta de Photremium procesa todo localmente en tu navegador. Las imágenes se cargan en memoria mediante File API y no se transmiten a internet. El render se hace con HTML5 Canvas en la pestaña del navegador. Al cerrar o pulsar “Start Over”, los datos se liberan. No se almacena nada fuera de tu dispositivo.',
          ],
        },
        {
          id: 'wm-blog-summary',
          tocLabel: 'Resumen final',
          title: 'Por qué la herramienta de marca de agua de Photremium merece un lugar fijo en tu flujo',
          paragraphs: [
            'Hay decenas de herramientas de marcas de agua. La diferencia entre una que merece guardarse y otra que se olvida suele ser velocidad, control y confianza.',
            'La velocidad importa porque el watermark no debería sumar tiempo. Photremium carga instantáneo, procesa localmente y exporta en resolución completa en segundos — incluso con grandes lotes. Sin colas ni esperas de servidor.',
            'El control importa porque un watermark mal hecho es peor que no tenerlo. El sistema de capas, los controles por propiedad, la vista previa en tiempo real y los atajos ofrecen control de nivel profesional.',
            'La confianza importa porque tu trabajo inédito es valioso. Saber que tus imágenes no viajan a ningún servidor permite marcar fotos de clientes, productos no lanzados o material sensible sin preocupación.',
            'Ya sea un aviso rápido en una sola foto o un lote de 200 imágenes, la herramienta de Photremium te da lo necesario para hacerlo bien — completamente gratis, completamente privado, con flexibilidad creativa para que la marca de agua se vea integrada.',
            'Entra en photremium.com/watermark-image y pruébalo. Tu primera imagen con marca está a literalmente treinta segundos.',
            'Photremium ofrece una suite de herramientas de imagen en el navegador. Todas funcionan localmente — tus imágenes se quedan en tu dispositivo.',
          ],
        },
      ],
    },
  },

  qrGenerator: {
    seo: {
      inputTitle: 'Generador de Código QR — Crear y personalizar gratis | photremium.com',
      inputDesc: 'Crea códigos QR personalizados para URLs, texto, WiFi, contactos, correo y Google Maps.',
      inputKeywords: 'generador de código qr, crear código qr',
      customizeTitle: 'Personalizar Código QR — photremium.com',
      customizeDesc: 'Personaliza el estilo, color, marco y logotipo del código QR.',
      customizeKeywords: 'personalizar código qr, colores código qr',
    },
    title: 'Generador de Código QR',
    desc: 'Genera, personaliza y descarga códigos QR para URLs, texto, WiFi, contactos, correo y mapas.',
    generate: 'Generar',
    scanQrCode: 'Escanear código QR',
    tabUrl: 'Enlace / URL',
    tabText: 'Texto',
    tabWifi: 'WiFi',
    tabContact: 'Contacto',
    tabEmail: 'Gmail',
    tabMaps: 'Google Maps',
    enterUrl: 'Ingresa URL',
    enterText: 'Ingresa texto',
    networkName: 'Nombre de red (SSID)',
    password: 'Contraseña',
    encryption: 'Cifrado',
    hiddenNetwork: 'Red oculta',
    contactName: 'Nombre de contacto (opcional)',
    phoneNumber: 'Número de teléfono',
    emailAddress: 'Dirección de correo',
    subject: 'Asunto (opcional)',
    body: 'Cuerpo (opcional)',
    searchLocation: 'Buscar ubicación',
    urlPlaceholder: 'https://ejemplo.com',
    textPlaceholder: 'Ingresa texto aquí…',
    wifiNamePlaceholder: 'Mi WiFi',
    passwordPlaceholder: 'Contraseña',
    contactPlaceholder: 'Juan Pérez',
    phonePlaceholder: '+34 XXX XXX XXX',
    emailPlaceholder: 'ejemplo@gmail.com',
    subjectPlaceholder: 'Asunto',
    bodyPlaceholder: 'Cuerpo del correo…',
    locationPlaceholder: 'Buscar ciudad, dirección, lugar…',
    wpaWpa2: 'WPA / WPA2',
    wep: 'WEP',
    none: 'Ninguno',
    characters: 'caracteres',
    qrGettingComplex: 'El código QR se está volviendo complejo — puede ser difícil de escanear.',
    qrTooComplex: '¡Código QR demasiado complejo! La mayoría de los escáneres no podrán leerlo.',
    generateCustomize: 'Generar y Personalizar',
    editQrData: 'Editar datos QR',
    styleShape: 'Estilo y Forma',
    colorTab: 'Color',
    framesTab: 'Marcos',
    logoTab: 'Logotipo',
    templatesTab: 'Plantillas',
    fileFormatTab: 'Formato de archivo',
    dotShape: 'Forma de punto',
    cornerEyeOuter: 'Ojo de esquina — Exterior',
    cornerEyeInner: 'Ojo de esquina — Interior',
    fgColor: 'Color de primer plano',
    bgColor: 'Color de fondo',
    enableGradient: 'Habilitar degradado',
    gradientType: 'Tipo de degradado',
    linear: 'Lineal',
    radial: 'Radial',
    gradientColor1: 'Color de degradado 1',
    gradientColor2: 'Color de degradado 2',
    suggestedGradients: 'Degradados sugeridos',
    selectFrame: 'Seleccionar marco',
    selectLogo: 'Seleccionar logotipo',
    uploadCustomLogo: 'O sube un logotipo personalizado',
    uploadImage: 'Subir imagen',
    customLogoApplied: 'Logotipo personalizado aplicado',
    premadeTemplates: 'Plantillas prediseñadas',
    templateHint: 'Haz clic en una plantilla para aplicar su combinación de estilo al instante.',
    downloadFormat: 'Formato de descarga',
    fgBgIdentical: '¡Los colores de primer plano y fondo son idénticos — el código QR será invisible!',
    fgBgSimilar: 'Los colores de primer plano y fondo son muy similares — el código QR puede ser difícil de escanear.',
    preview: 'Vista previa',
    angle: 'Ángulo',
    downloadFormatBtn: 'Descargar {format}',
    pngDesc: 'Sin pérdida, soporte de transparencia',
    jpgDesc: 'Formato de archivo popular/universal',
    webpDesc: 'Formato moderno, mejor relación calidad/tamaño',
    svgDesc: 'Gráficos vectoriales escalables',
    pdfDesc: 'Documento listo para imprimir',
    lat: 'Latitud:',
    lng: 'Longitud:',
    qrCode: 'Código QR',
    scanMe: 'ESCANÉAME',
    scanHere: 'ESCANEAR AQUÍ',
    blog: {
      card1: {
        title: '1. ¿Qué es un código QR?',
        intro1: 'La forma completa de QR es “Quick Response code” (código de respuesta rápida). Como la información almacenada se decodifica muy rápido, se llama código QR.',
        intro2: 'El código QR es un código digital bidimensional que solo puede ser leído por máquinas. Los humanos no pueden leer directamente los datos que contiene. Incluye bloques para almacenar información como texto, números de contacto, enlaces y ubicaciones de Google Maps, etc.',
        inventionTitle: 'Cómo se inventó el código QR:',
        inventionText: 'El código QR se inventó en 1994. Masahiro Hara y su equipo trabajaban en una empresa japonesa llamada Denso Wave, que fabricaba piezas de automóvil para Toyota. Querían un código que almacenara mucha más información que un código de barras típico, y así inventaron el código QR.',
        keyFeaturesTitle: 'Características clave de un código QR',
        keyFeatures: [
          {
            title: 'Cómo funciona el QR',
            text: 'Introduces el texto o el enlace para generar su código QR. El generador crea cuadros según la información. Cada cuadro representa un bit y cada bit almacena un carácter.',
          },
          {
            title: 'Estructura del código QR',
            text: 'Un código QR contiene tres cuadros grandes para identificar su orientación, y cuadros pequeños para almacenar los bits (información).',
          },
          {
            title: 'Capacidad de datos del código QR',
            text: 'Normalmente, un código QR almacena más información que un código de barras. Es básicamente una versión avanzada y bidimensional del código de barras. Un código QR almacena casi 200 caracteres. También puede almacenar 400 caracteres, pero puede resultar difícil de escanear. Almacenar más de 400 caracteres puede generar un código QR muy complejo que, en la mayoría de los casos, no se podrá escanear.',
          },
          {
            title: 'Detección de errores en códigos QR',
            text: 'Un código QR puede seguir siendo escaneable incluso si parte de la información está rayada o algunos bits se alteran. El código QR usa la técnica Reed-Solomon para detectar errores y corregirlos después de identificarlos.',
          },
        ],
        errorTitle: 'Nivel de corrección de errores del código QR:',
        errorIntro: 'Se usan diferentes técnicas de detección y corrección de errores según el caso, como se describe a continuación:',
        errorHeaders: {
          level: 'Nivel',
          recovery: 'Capacidad de recuperación',
          bestUse: 'Mejor caso de uso',
        },
        errorRows: [
          {
            level: 'Bajo (L)',
            recovery: '~7%',
            useCases: [
              'Se usa cuando el código QR se muestra en pantallas digitales, sitios web o entornos limpios.',
              'Cuando el código QR se genera para información pequeña como Gmail, número de contacto o texto corto.',
            ],
          },
          {
            level: 'Medio (M)',
            recovery: '~15%',
            useCases: [
              'Para folletos y pósters instalados en entornos limpios, cuando el riesgo de daño es mínimo.',
            ],
          },
          {
            level: 'Cuartil (Q)',
            recovery: '~25%',
            useCases: [
              'Cuando el código QR se instalará en entornos agresivos como fábricas o exteriores.',
              'También cuando se necesita un logotipo pequeño en el centro, porque cubre algunos bits. En ese caso se requiere este nivel de corrección.',
            ],
          },
          {
            level: 'Alto (H)',
            recovery: '~30%',
            useCases: [
              'Se usa cuando es posible un daño considerable del código QR.',
              'Cuando logotipos grandes cubren el centro del código QR.',
              'También cuando se necesita mucho estilo visual en el código QR.',
            ],
          },
        ],
      },
      card2: {
        title: '2. ¿Por qué elegir nuestro generador de códigos QR?',
        intro: 'Nuestro generador de códigos QR hace que la creación sea extremadamente rápida, segura y sencilla. Puedes personalizar tu código para que sea más avanzado, profesional y acorde al tema de tu negocio. Todas las personalizaciones, desde el color hasta la instalación de logotipo, se ofrecen gratis para siempre.',
        strengths: [
          {
            title: 'Personalización profesional:',
            text: 'Puedes generar y personalizar tantos códigos QR como necesites sin ningún costo. Todas las funciones son totalmente gratuitas. Puedes aplicar colores degradados, diferentes formas de módulos, logotipos personalizados y muchas opciones más.',
          },
          {
            title: 'Soporte de múltiples formatos:',
            text: 'Nuestro generador ofrece varios formatos de descarga para tu comodidad. Solo debes elegir el formato antes de descargar. Actualmente ofrecemos estos formatos:',
          },
          {
            title: 'Plantillas predefinidas:',
            text: 'Puedes usar degradados y marcos predefinidos que hacen que tu código QR se vea más profesional.',
          },
          {
            title: 'Compatibilidad con logotipo personalizado:',
            text: 'También puedes subir el logotipo de tu marca, que se ajusta automáticamente en el centro del código QR. Además, puedes elegir un logotipo de la biblioteca integrada, donde hay más de 30 opciones.',
          },
          {
            title: 'Vista previa en vivo:',
            text: 'Mientras personalizas, puedes ver todos los cambios en un panel de vista previa en tiempo real.',
          },
          {
            title: 'Indicador de escaneo:',
            text: 'Al elegir colores, recibirás advertencias e indicadores si seleccionas combinaciones difíciles de escanear.',
          },
        ],
        formatHeaders: {
          srNo: 'N.º',
          formats: 'Formatos',
          description: 'Descripción',
        },
        formatRows: [
          { no: '1', format: 'PNG', description: 'Sin pérdida, soporte de transparencia' },
          { no: '2', format: 'JPG', description: 'Formato de archivo popular y universal' },
          { no: '3', format: 'WEBP', description: 'Formato moderno, mejor calidad/tamaño' },
          { no: '4', format: 'SVG', description: 'Gráfico vectorial escalable' },
          { no: '5', format: 'PDF', description: 'Documento listo para imprimir' },
        ],
      },
      card3: {
        title: '3. Guía paso a paso:',
        step1Intro: 'Primero, selecciona la categoría del código QR que quieres generar. Ya sea para contacto, mapa, enlace o texto. Actualmente, nuestro generador ofrece estas categorías:',
        categories: ['Enlace / URL', 'Texto', 'WiFi', 'Contacto', 'Gmail', 'Google Maps'],
        step2: 'Después de seleccionar la categoría, pega tu información en el cuadro de texto correspondiente.',
        step3Intro: 'Luego, haz clic en Generar y Personalizar para abrir el panel de personalización. En este panel verás una barra de navegación con las siguientes opciones:',
        options: [
          {
            title: 'Estilo y forma:',
            text: 'En esta sección puedes cambiar la forma de los módulos a múltiples estilos como esquinas redondeadas, puntos, barras horizontales, barras verticales, cuadros pequeños y muchos otros.',
          },
          {
            title: 'Color:',
            text: 'Puedes seleccionar tus colores de fondo y primer plano. Para crear códigos QR con degradados, puedes activar la opción de degradado para aplicar colores de la biblioteca integrada o crear tu propio degradado. También puedes cambiar el ángulo del degradado lineal. El degradado radial también es compatible. Puedes añadir múltiples colores para obtener un efecto profesional.',
          },
          {
            title: 'Marcos:',
            text: 'Aquí puedes seleccionar un marco ideal para tu código QR. Todos los marcos se ajustan automáticamente al código. Solo debes elegir uno de la biblioteca integrada.',
          },
          {
            title: 'Logotipo:',
            text: 'Después de seleccionar el marco, puedes elegir un logotipo que se ajusta automáticamente en el centro del código QR. También se admite la carga de logotipo personalizado de marca.',
          },
          {
            title: 'Plantillas:',
            text: 'Si no quieres elegir estilo, forma, color y marco por separado, puedes aplicar plantillas predefinidas en tu código QR. Se ofrecen múltiples plantillas premium gratis para siempre.',
          },
          {
            title: 'Formato de archivo:',
            text: 'Finalmente, debes seleccionar el tipo de archivo en el que quieres descargar el código QR. Se admiten varios formatos comunes, como PNG, WEBP, SVG y PDF, etc.',
          },
          {
            title: 'Editar datos QR:',
            text: 'También puedes editar los datos de tu QR sin perder las personalizaciones seleccionadas.',
          },
        ],
        finalStep: 'Después, solo haz clic en el botón de descarga y el código QR, exactamente según tus personalizaciones y en el formato seleccionado, se descargará al instante sin costo.',
      },
      card4: {
        title: '4. Beneficios:',
        intro: 'El código QR conecta el mundo físico con la experiencia digital. Es la forma más rápida de compartir enlaces, contacto o ubicación. Solo tienes que escanear ese código QR para acceder a la información al instante. Por eso es muy popular en los negocios y en el mundo digital, por su eficiencia de tiempo y utilidad.',
        benefits: [
          {
            title: 'Soporte de por vida:',
            text: 'Los códigos QR funcionan para siempre sin caducar. Te dan la información almacenada al instante cuando los escaneas. Como guardan instrucciones digitales fijas, nunca pierden su información.',
          },
          {
            title: 'Soporte sin conexión:',
            text: 'Puedes escanear el código QR incluso si estás sin internet. La cámara de tu móvil decodifica los patrones del código QR y te muestra la información almacenada.',
          },
          {
            title: 'Costo cero:',
            text: 'Como estos códigos no requieren redirecciones de servidor ni recursos adicionales, son gratuitos para siempre.',
          },
        ],
      },
    },
  },

  qrScanner: {
    seo: {
      title: 'Escáner de Código QR — Escanear con cámara o imagen | photremium.com',
      desc: 'Escanea códigos QR al instante con la cámara o sube una imagen. Rápido, privado y seguro.',
      keywords: 'escáner qr, escanear código qr, lector qr',
    },
    title: 'Escáner de Código QR',
    desc: 'Escanea códigos QR al instante con la cámara o sube una imagen. Rápido, privado y seguro.',
    generateQrCode: 'Generar código QR',
    scan: 'Escanear',
    cameraScanner: 'Escáner de cámara',
    uploadImage: 'Subir imagen',
    pointCamera: 'Apunta la cámara a un código QR',
    startCamera: 'Iniciar cámara',
    loading: 'Cargando…',
    dropQrImage: 'Suelta la imagen del código QR aquí',
    toScan: 'para escanear',
    supportedFormats: 'Compatible con JPG, PNG, GIF, WEBP',
    ctrlVPaste: 'Ctrl+V para pegar',
    scanFromGallery: 'Escanear desde galería',
    instantScanning: 'Escaneo instantáneo',
    instantScanningDesc: 'Reconocimiento de código QR en tiempo real desde cámara o imágenes subidas',
    private100: '100% Privado',
    private100Desc: 'Todo el procesamiento ocurre en tu navegador. Nada se sube',
    multiFormat: 'Multi-formato',
    multiFormatDesc: 'Detecta URLs, texto, WiFi, contactos, correo, teléfono y más',
    accessingCamera: 'Accediendo a la cámara…',
    cameraDenied: 'Acceso a cámara denegado. Permite el permiso de cámara e intenta de nuevo.',
    noCamera: 'No se encontró cámara en este dispositivo.',
    cameraError: 'No se pudo acceder a la cámara. Intenta de nuevo.',
    videoError: 'No se pudo iniciar la reproducción de video.',
    switchError: 'No se pudo cambiar la cámara.',
    tryAgain: 'Intentar de nuevo',
    switchCamera: 'Cambiar cámara',
    stop: 'Detener',
    noQrFound: 'No se encontró código QR',
    couldNotRead: 'No se pudo leer la imagen',
    scannerFailed: 'No se pudo cargar el escáner',
    noQrFoundDesc: 'No se detectó código QR en la imagen. Intenta con otra imagen o usa el escáner de cámara.',
    qrScanned: '¡Código QR escaneado!',
    openLink: 'Abrir enlace',
    copied: '¡Copiado!',
    copy: 'Copiar',
    share: 'Compartir',
    scanAgain: 'Escanear de nuevo',
    network: 'Red',
    password: 'Contraseña',
    security: 'Seguridad',
    unknown: 'Desconocido',
    typeText: 'Texto',
    typeUrl: 'URL',
    typeWifi: 'Red WiFi',
    typeContact: 'Tarjeta de contacto',
    typeEmail: 'Correo electrónico',
    typePhone: 'Número de teléfono',
    typeSms: 'SMS',
    typeLocation: 'Ubicación',
    blog: {
      tocTitle: 'Contenido',
      sections: [
        {
          id: 'why-use-qr-code-scanner',
          title: '1. ¿Por qué usar un escáner de código QR?',
          paragraphs: [
            'Un escáner de código QR es básicamente una cámara móvil que decodifica la información almacenada en el código QR. Solo tienes que apuntar la cámara al código QR; sin importar la orientación del código, leerá los patrones específicos, detectará errores, corregirá los errores si es necesario y mostrará la información que contiene.',
          ],
          listTitle: 'Tipos de escáneres de código QR:',
          bullets: [
            'Escáner de código QR basado en web: Puedes escanear el código QR con escáneres en línea compatibles con tu navegador. Puedes acceder a la información por cámara o escaneando al subir la imagen. Para redirección automática y otras funciones avanzadas, puedes visitar https://photremium.com.',
            'Cámaras móviles: Algunos móviles modernos tienen escáner de código QR integrado en sus apps de cámara originales. Pueden obtener y decodificar la información solo escaneando el código QR con una cámara simple.',
            'Apps: Hay algunas apps creadas específicamente para escanear códigos QR. Sin embargo, para redirección avanzada y muchas otras funciones, puedes instalar la app desde este enlace gratis: https://photremium.com.',
            'Dispositivos de hardware: También existen dispositivos de hardware para escanear códigos QR. Estos dispositivos se usan ampliamente en grandes centros comerciales para la facturación de artículos.',
          ],
        },
        {
          id: 'why-choose-our-qr-code-scanner',
          title: '2. ¿Por qué elegir nuestro escáner de código QR?',
          paragraphs: [
            'Puedes explorar múltiples funciones avanzadas, desde la redirección hasta copiar el contenido decodificado del código QR. Puedes explorar muchas otras funciones interesantes en nuestro escáner de código QR como:',
          ],
          bullets: [
            'Alta velocidad: Nuestro escáner de código QR hace que la decodificación del código QR sea extremadamente rápida. Solo tienes que escanear el código QR y nuestra herramienta te da la información al instante con opción avanzada para copiar el texto/enlace, abrir si se detecta un enlace o guardar automáticamente si se detecta un contacto.',
            'No requiere instalación: No tienes que instalar ninguna app separada para acceder a nuestro escáner de código QR. Puedes acceder a esta herramienta desde tu navegador local gratis.',
            'Acceso multiplataforma: Puedes acceder desde cualquier dispositivo. No te preocupes por la versión del sistema operativo ni por ningún otro requisito. Es compatible con todas las versiones y todos los dispositivos.',
            'Compatibilidad con todos los formatos: Nuestra herramienta admite todos los formatos de datos que pueden almacenarse en un código QR, incluyendo texto plano, WiFi, URLs, contactos, Gmail y Google Maps, etc.',
          ],
        },
        {
          id: 'step-by-step-guide',
          title: '3. Guía paso a paso:',
          steps: [
            {
              heading: '1. Antes que nada, elige un método para escanear el código QR. Hay dos métodos para hacerlo:',
              subSteps: [
                {
                  heading: 'i. Método de cámara',
                  paragraphs: [
                    'Puedes escanear el código QR usando la cámara de tu dispositivo incluso si usas una laptop, una PC o cualquier dispositivo que tenga una cámara simple. Al hacer clic en el botón “Iniciar cámara”, aparecerá una solicitud de permiso; permite el permiso para que este sitio use tu cámara para escanear QR. Si lo rechazaste por accidente o no aparece la solicitud, puedes otorgar acceso a la cámara manualmente siguiendo estos pasos:',
                  ],
                  notes: [
                    '➔ Para Chrome (Android / Escritorio):',
                    '1. Haz clic en los tres puntos',
                    '2. Ve a Configuración',
                    '3. (Omitir este paso en Android) Privacidad y seguridad',
                    '4. Haz clic en Configuración de sitios',
                    '5. Luego, en la sección de permisos, haz clic en Cámara',
                    '6. Busca la URL de nuestro sitio: https://photremium.com/qr-code-scanner',
                    '7. Permite la cámara desde el menú desplegable.',
                    '➔ Para Safari (iPhone / iOS):',
                    '1. Toca el ícono AA o Configuración del sitio en la barra de direcciones.',
                    '2. Selecciona Configuración del sitio web.',
                    '3. Toca Cámara y elige Permitir.',
                    '4. Si sigue bloqueado: ve a Ajustes del iPhone > Safari > Cámara y configúralo en Preguntar o Permitir.',
                  ],
                },
                {
                  heading: 'ii. Método de galería',
                  paragraphs: [
                    'Puedes subir la imagen de un código QR para acceder a su información. Haz clic en el botón “Escanear desde galería” y se abrirá el explorador de archivos. Luego, selecciona la imagen del código QR. Se admiten todos los formatos de imagen como .jpg, .jpeg, .png, .gif, .webp, .svg, .avif, .heic, .heif, .jxl, .bmp, .ico, .tiff, .tif, .jfif, .jpe, .pjpeg, .pjp, .apng, .svgz y .xbm, etc.',
                  ],
                },
              ],
            },
            {
              heading: '2. Cuando selecciones el código QR, se mostrará toda la información; permitiéndote copiar, compartir o abrir el enlace si se detecta. También puedes volver a escanear si quieres.',
            },
          ],
        },
        {
          id: 'benefits-of-qr-code-scanner',
          title: 'Beneficios del escáner de código QR:.',
          paragraphs: [
            'El escáner de código QR ofrece varios beneficios en este mundo digital. Hace que los pagos, verificaciones y el acceso a la información sean fáciles y rápidos incluso en modo sin conexión.',
          ],
          bullets: [
            'Acceso instantáneo a la información: Escanear el código QR proporciona la información en milisegundos. Decodifica patrones, detecta errores y los elimina rápidamente, ofreciendo una experiencia extremadamente rápida al usuario.',
            'Comunicación fluida: En esta era de avance, hay una gran necesidad de comunicación rápida y segura para información pequeña como datos bancarios y detalles de productos, etc. El escáner de código QR resuelve este problema ya que los pagos se hacen escaneando un código QR. Además, Google verifica el teléfono móvil vía QR al crear una cuenta nueva en laptop.',
            'E-Tickets: En estaciones de autobús, estaciones de tren o aeropuertos, puedes verificar fácilmente tus boletos sin esperar mucho tiempo en filas. Además, en aeropuertos hay escáneres de código QR instalados en múltiples sitios para evitar filas. Esto también minimiza la necesidad de empleados, ahorrando automáticamente el presupuesto de la aerolínea.',
            'Autenticación de productos: Las marcas avanzadas y de alta gama colocan un código QR en su producto. El cliente puede escanear ese código QR para comprobar la autenticidad del producto, si es original o no.',
          ],
        },
      ],
    },
  },

  faceBlur: {
    seo: {
      uploadTitle: 'Difuminar Caras — Ocultar caras en imágenes en línea | photremium.com',
      uploadDesc: 'Difumina caras en imágenes automáticamente con reconocimiento facial por IA. Gratis, rápido y privado.',
      uploadKeywords: 'difuminar cara, ocultar caras, reconocimiento facial',
      workspaceTitle: 'Difuminar Caras — photremium.com',
      workspaceDesc: 'Difumina caras en imágenes automáticamente. 100% gratis, rápido y privado.',
      workspaceKeywords: 'difuminar cara',
    },
    title: 'Difuminar Cara',
    desc: 'Detecta y difumina automáticamente caras en imágenes para mayor privacidad.',
    toBlurFaces: 'Difuminar caras',
    autoDetection: 'Detección automática',
    autoDetectionDesc: 'El reconocimiento facial por IA encuentra todas las caras al instante',
    customBlur: 'Difuminado personalizado',
    customBlurDesc: 'Personaliza la intensidad, forma y estilo del difuminado',
    private100: '100% Privado',
    private100Desc: 'Todo el procesamiento ocurre localmente en tu navegador',
    blurTools: 'Herramientas de difuminado',
    faces: 'Caras',
    faceDetection: 'Detección de caras',
    detecting: 'Detectando...',
    autoDetectFaces: 'Detectar caras automáticamente',
    exitManualMode: 'Salir del modo manual',
    manualSelect: 'Selección manual',
    nFaceRegions: '{n} región(es) de cara encontrada(s)',
    noFacesDetected: 'No se detectaron caras — usar modo manual',
    manualHint: 'Haz clic y arrastra sobre la imagen para dibujar un rectángulo sobre el área a difuminar.',
    blurType: 'Tipo de difuminado',
    blur: 'Difuminar',
    emoji: 'Emoji',
    blurIntensity: 'Intensidad de difuminado',
    strength: 'Intensidad',
    blurShape: 'Forma de difuminado',
    rectangle: 'Rectángulo',
    ellipse: 'Elipse',
    circle: 'Círculo',
    chooseEmoji: 'Elegir emoji',
    blurRegionsN: 'Regiones de difuminado ({n})',
    faceN: 'Cara {n}',
    manualRegionN: 'Región manual {n}',
    manualN: 'Manual {n}',
    clearAllRegions: 'Limpiar todas las regiones',
    processingDots: 'Procesando...',
    downloadBlurred: 'Descargar imagen difuminada',
    downloadNImages: 'Descargar {n} imágenes',
    downloadDialogTitle: 'No todas las imágenes editadas',
    downloadDialogText: 'Has editado {edited} de {total} imágenes.',
    downloadAll: 'Descargar todo',
    removeRegion: 'Eliminar región',
    region: 'Región',
    notAllEdited: 'No todas las imágenes editadas',
    editedXofY: 'Has editado {edited} de {total} imágenes.',
    nextImage: 'Siguiente imagen',
  },

  faqData: {
    imageConverter: [
      { q: '¿Qué formatos de imagen se admiten para la conversión?', a: 'Admitimos JPG, PNG, WEBP, SVG, GIF, BMP, ICO y TIFF. Puedes convertir entre cualquiera de estos formatos al instante en tu navegador.' },
      { q: '¿Se verá afectada la calidad de la imagen durante la conversión?', a: 'Para formatos sin pérdida como PNG, la calidad se conserva totalmente. Para formatos con pérdida como JPG y WEBP, usamos configuraciones de codificación optimizadas para mantener la mejor calidad visual posible.' },
      { q: '¿Hay límite de tamaño de archivo o cantidad?', a: 'No hay límite estricto. Puedes subir varias imágenes a la vez y convertirlas en lote. Como todo se ejecuta localmente en tu navegador, la velocidad depende de tu dispositivo.' },
      { q: '¿Están seguros mis datos? ¿Se suben las imágenes a un servidor?', a: 'Absolutamente. Todo el procesamiento ocurre al 100% en tu navegador. Tus imágenes nunca abandonan tu dispositivo.' },
      { q: '¿Puedo convertir imágenes PNG transparentes a JPG?', a: 'Sí. Como JPG no admite transparencia, las áreas transparentes se rellenarán con un fondo blanco de forma predeterminada.' },
    ],
    imageCompressor: [
      { q: '¿Comprimir la imagen reducirá su calidad?', a: 'No, comprimir la imagen no afecta su calidad, salvo que se excedan los límites recomendados. Los indicadores te guían así: i. Compresión de 1 a 40%: verás un indicador verde con el mensaje “Buena calidad”. ii. Compresión de 41 a 60%: verás una señal amarilla con el mensaje “Calidad normal”. Esta franja se recomienda para buenos resultados. iii. Compresión de 61 a 100%: el sistema mostrará una advertencia roja con el mensaje “Mala calidad”. En este rango la calidad puede verse afectada de forma notable.' },
      { q: '¿Qué formatos de imagen son compatibles con la compresión?', a: 'Nuestra herramienta de compresión admite todos estos formatos:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: '¿Puedo comprimir varias imágenes a la vez?', a: 'Sí, totalmente. Puedes comprimir varias imágenes (incluso 100+) al mismo tiempo, si tu dispositivo lo permite. Como la compresión usa recursos de tu sistema, para lotes muy grandes conviene usar un equipo de buen rendimiento. Si tu dispositivo es más básico, puedes comprimir en tandas; la herramienta sigue siendo gratuita sin límites de uso.' },
      { q: '¿Guardan o suben nuestras imágenes a sus servidores?', a: 'No. Nunca subimos ni almacenamos tus imágenes en nuestros servidores. Todo se comprime localmente en tu navegador. Tus imágenes no salen de tu dispositivo, así que puedes usar la herramienta con tranquilidad incluso para contenido privado.' },
      { q: '¿Esta herramienta de compresión de imágenes es gratuita?', a: 'Sí. Nuestro compresor de imágenes es totalmente gratuito para siempre. Nunca te pediremos pago, no hay cargos ocultos y todas las funciones —incluida la compresión múltiple— son gratis.' },
    ],
    cropImage: [
      { q: '¿Recortar la imagen reducirá su calidad?', a: 'No, recortar la imagen nunca afectará la calidad visual de la imagen en absoluto. Recortar la imagen solo descarta las partes no deseadas. Nunca cambia los píxeles de la parte de la imagen que se va a recortar. Por lo tanto, puedes recortar tus imágenes con su calidad original sin ningún daño de píxeles.' },
      { q: '¿Qué formatos de imagen son compatibles para el recortador de imágenes?', a: 'Puedes seleccionar cualquier imagen de cualquier formato, ya que nuestra herramienta de recorte de imágenes ofrece casi todos los formatos de imagen. Estos se enumeran a continuación:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: '¿Mis imágenes se suben a su servidor?', a: 'No, todo el procesamiento se realizará en tu navegador local. Tus imágenes nunca se subirán a nuestro servidor, ya que nunca salen de tu dispositivo. Por lo tanto, puedes recortar tus imágenes personales con nuestro recortador de imágenes sin ningún riesgo.' },
      { q: '¿Puedo recortar varias imágenes a la vez?', a: 'Sí, puedes recortar varias imágenes (incluso más de 100) a la vez si tu sistema lo permite. Como el recorte de imágenes usa los recursos de tu sistema, si tienes un portátil, PC o móvil de alto rendimiento, puedes recortar muchas imágenes a la vez. Si tienes un dispositivo de gama baja, puedes recortar imágenes en lotes, ya que esta herramienta es gratuita incluso si recortas múltiples imágenes a la vez.' },
      { q: '¿Esta herramienta de recorte de imágenes es gratuita?', a: 'Sí, esta herramienta de recorte de imágenes es totalmente gratuita para siempre. Puedes acceder a esta herramienta en cualquier lugar, en cualquier momento y usando cualquier dispositivo. No solo experimentarás un diseño adaptable para todos los dispositivos, sino que además nunca se te pedirá pagar por ninguna función premium. Todas las funciones son totalmente gratuitas y sin cargos ocultos.' },
    ],
    resizeImage: [
      { q: '¿Puedo redimensionar varias imágenes a la vez?', a: 'Por supuesto, nuestra herramienta permite redimensionar varias imágenes al mismo tiempo. Solo sube tantas imágenes como soporte tu dispositivo y nuestro motor con IA redimensionará todas de una vez. Si tienes un dispositivo de gama baja, prueba hacerlo en varios lotes para evitar retrasos. El redimensionado usa recursos del dispositivo para evitar subidas al servidor y proteger tu privacidad.' },
      { q: '¿Esta herramienta de redimensionado es gratuita?', a: 'Sí, esta herramienta es gratuita para siempre. Nunca se te pedirá una suscripción de pago para desbloquear funciones premium. No hay cargos ocultos para descargar tus imágenes redimensionadas.' },
      { q: '¿Redimensionar la imagen reducirá su calidad?', a: '✅Decrease Size (downscale): Reducir el tamaño de la imagen no reducirá su calidad visual. De hecho, la imagen redimensionada puede verse más nítida que la original. Por lo tanto, reducir a dimensiones más pequeñas no disminuye la calidad.\n❌Increase Size (upscale): Aumentar el tamaño por encima del original puede afectar la calidad visual. La gravedad depende de cuánto aumentes el tamaño. Cuanto más aumentes, más caerá la calidad.' },
      { q: '¿Esta herramienta de redimensionado es segura?', a: 'Sí, nuestra herramienta es totalmente segura, especialmente para imágenes personales o privadas, ya que todo se procesa localmente. Ninguno de tus datos saldrá de tu dispositivo durante el procesamiento. Puedes redimensionar tus imágenes personales sin riesgo.' },
      { q: '¿Qué formatos de imagen se admiten?', a: 'Todos los formatos de imagen están admitidos en nuestra herramienta. Puedes seleccionar imágenes en estos formatos:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
    ],
    removeBackground: [
      { q: '¿Cómo funciona la eliminación de fondo?', a: 'Usamos un modelo de IA avanzado que se ejecuta directamente en tu navegador para detectar el sujeto y separarlo del fondo, produciendo un PNG transparente.' },
      { q: '¿Funciona con fondos complejos?', a: 'Sí. El modelo de IA maneja gran variedad de escenas. Los mejores resultados se obtienen con un contraste claro entre el sujeto y el fondo.' },
      { q: '¿Puedo eliminar fondos de varias imágenes a la vez?', a: 'Sí. Sube varias imágenes y la herramienta las procesará secuencialmente. Puedes descargar todos los resultados como ZIP.' },
      { q: '¿Cuál es el formato de salida?', a: 'La salida siempre es un archivo PNG con fondo transparente, que puedes superponer en cualquier diseño.' },
      { q: '¿Se envían mis imágenes a un servidor?', a: 'No. El modelo de IA se ejecuta completamente en tu navegador usando WebAssembly.' },
    ],
    watermarkImage: [
      { q: '1. ¿La herramienta de marca de agua de Photremium es completamente gratuita?', a: 'Sí, la herramienta de photremium.com/watermark-image es totalmente gratuita, sin cuenta y sin suscripción. Puedes marcar una sola imagen o lotes completos sin paywalls, sin registros forzados y sin límites de descarga. La herramienta se financia por el valor global de Photremium, no por bloquear funciones esenciales.' },
      { q: '2. ¿Cuántas imágenes puedo marcar a la vez?', a: 'La herramienta permite marcar varias imágenes simultáneamente. Puedes arrastrar una carpeta completa a la zona de subida o seleccionar docenas de archivos con Ctrl+Click. La tira de miniaturas de la izquierda muestra todos los archivos y, al pulsar "Watermark & Download All", la herramienta renderiza cada imagen y las empaqueta en un ZIP (o las descarga por separado — tú eliges). En la práctica, el límite es la memoria disponible del dispositivo, no un tope impuesto.' },
      { q: '3. ¿Qué formatos están soportados para entrada y salida?', a: 'La entrada admite formatos que el File API del navegador puede manejar — normalmente JPEG, JPG, PNG, WEBP, GIF (estático), BMP y SVG. La salida conserva el formato original: si subes PNG, recibes PNG; si subes JPEG, recibes JPEG a 0.95 de calidad. Esto evita convertir un PNG sin pérdida en un JPG con pérdida por accidente.' },
      { q: '4. ¿La marca de agua se verá igual en imágenes con diferentes resoluciones?', a: 'Sí, gracias al motor de posicionamiento proporcional. Cuando trabajas con imágenes de distintos tamaños, la marca se diseña en la imagen de referencia. Al exportar, el motor calcula la posición de cada capa como un desplazamiento fraccional desde el centro y aplica la misma proporción a cada imagen. El tamaño también se escala proporcionalmente usando el menor factor (ancho vs. alto) para evitar que se salga del lienzo. Resultado: misma posición y tamaño relativos en todo el lote.' },
      { q: '5. ¿Puedo usar mi propio logo o firma como marca de agua?', a: 'Sí. El botón "Add Image" del panel derecho te permite subir cualquier imagen como capa de marca de agua. Los PNG con fondo transparente funcionan mejor: la transparencia se mantiene y solo se ve el logo. Puedes redimensionarlo con las esquinas (manteniendo la proporción), rotarlo, voltearlo, ajustar la opacidad e incluso añadir borde o esquinas redondeadas. Muchos usuarios guardan una versión transparente del logo para este fin.' },
      { q: '6. ¿Cómo hago la marca de agua transparente o semitransparente?', a: 'Selecciona la capa en el lienzo. En la barra superior verás el control de opacidad con porcentaje; puedes escribir un valor o arrastrar. Para una marca discreta, lo habitual es 30–50%. Para una más evidente, 70–80%. También puedes alternar la visibilidad desde el gestor de capas (icono del ojo) para comparar.' },
      { q: '7. ¿Puedo añadir varias marcas de agua en una sola imagen?', a: 'Sí — el sistema de capas permite un número ilimitado de marcas, cada una con su propia configuración. Puedes combinar un aviso de copyright abajo a la derecha, un logo arriba a la izquierda y un patrón "SAMPLE" en mosaico. Cada capa tiene su opacidad, rotación, posición, tamaño y estilo. El gestor de capas las organiza y permite ocultarlas/mostrarlas sin borrarlas para probar variantes.' },
      { q: '8. ¿Qué hace el mosaico y cuándo debería usarlo?', a: 'El mosaico repite la marca en una cuadrícula por toda la imagen. Grid 2×2 coloca cuatro copias; Grid 3×3 coloca nueve. El control de espaciado regula la distancia entre copias. Es ideal cuando quieres que la imagen no pueda reutilizarse sin permiso — una marca en una esquina se recorta fácilmente, pero un patrón completo es difícil de eliminar sin dañar la imagen. Se usa en previews de contratos, borradores o contenidos antes del pago.' },
      { q: '9. ¿Funciona en móviles y tablets?', a: 'Sí, la herramienta es totalmente responsive y está pensada para móvil. En pantallas menores a 900 px, el diseño se apila: las miniaturas pasan a una fila horizontal, el lienzo ocupa el centro y el panel de ajustes aparece como hoja inferior activada por un botón flotante. Todas las interacciones — arrastrar, redimensionar, rotar — funcionan con gestos táctiles. Los tiradores son más grandes en móvil (16×16 px) para facilitar el uso.' },
      { q: '10. ¿Mis datos son privados? ¿Se suben las fotos a un servidor?', a: 'Tus imágenes no salen de tu dispositivo. Todo el flujo — cargar, renderizar, exportar — se ejecuta en el navegador con JavaScript y la HTML5 Canvas API. La File API carga el archivo en memoria, las capas se dibujan en un canvas oculto y el resultado se convierte en un Blob para descargar localmente. No hay solicitudes de red con datos de imagen. Además, existe un aviso al salir: si intentas cerrar la página con imágenes cargadas, el navegador pide confirmación para evitar pérdida accidental de trabajo.' },
    ],
    qrCodeGenerator: [
      { q: '¿Este código QR caduca?', a: 'No, estos códigos QR no caducan y ofrecen soporte de por vida. Como almacenan instrucciones codificadas en forma de bits dentro de módulos cuadrados, la información guardada en ellos no puede eliminarse. Puedes acceder a la información escaneándolo con cualquier cámara incluso después de años.' },
      { q: '¿Por qué mi código QR no se escanea?', a: 'Tu código QR puede no escanearse por las siguientes razones: i. Bajo contraste: si eliges colores de fondo y primer plano muy similares, se reduce la visibilidad y falla el escaneo. Nuestra herramienta te guía durante la personalización sobre bajo contraste y otros problemas de lectura. ii. Datos muy grandes: si generas un código QR para un texto muy largo, se vuelve complejo y puede causar problemas al escanear. Un validador de longitud de texto te guía sobre el tamaño óptimo durante la generación del QR. iii. Impresión borrosa: asegúrate de descargar tu código QR en alta resolución, como PNG o SVG, formatos ya compatibles con nuestra herramienta.' },
      { q: '¿Puedo añadir un logotipo en el código QR?', a: 'Sí, puedes añadir un logotipo personalizado o seleccionar uno de la biblioteca de logotipos integrada para tu código QR. El logotipo seleccionado se ajustará automáticamente en el centro del código QR.' },
      { q: '¿Cómo puedo escanear el código QR?', a: 'Puedes escanear el código QR usando la cámara de tu móvil. Pero para redirección automática a enlaces y muchas funciones avanzadas, puedes visitar gratis nuestro escáner QR en https://photremium.com/qr-code-scanner.' },
      { q: '¿Cuántos códigos QR puedo generar gratis?', a: '¡ILIMITADOS! Puedes generar múltiples códigos QR gratis. Todas las funciones, personalizaciones y plantillas son gratis para siempre. No necesitas suscribirte para usar funciones premium.' },
      { q: '¿Necesito iniciar sesión/registrarme para generar un código QR?', a: 'No. Solo introduce tu texto, genera el código QR y descárgalo después de personalizarlo. No es necesario iniciar sesión ni registrarse, ya que todas las funciones están disponibles completamente gratis.' },
    ],
    qrCodeScanner: [
      { q: '¿Puedo escanear códigos QR desde imágenes guardadas y capturas de pantalla?', a: '**Sí**, puedes escanear un código QR desde imágenes guardadas o capturas de pantalla. Nuestro escáner de código QR https://photremium.com/qr-code-scanner te permite escanear el código QR desde la galería. Solo tienes que seleccionar la imagen y obtendrás toda la información decodificada de ese código QR.' },
      { q: '¿Necesito instalar la app para usar el escáner de código QR?', a: '**No**, nuestro escáner de código QR basado en web te permite escanear códigos QR sin necesidad de instalar ninguna app. Puedes acceder a nuestro escáner de código QR avanzado en cualquier dispositivo gratis.' },
      { q: '¿Por qué el escáner no reconoce el código QR?', a: 'Tu código QR no se está escaneando por alguna de las siguientes razones: i. Luz insuficiente: Escanear el código QR con poca luz puede causar problemas de escaneo. Enciende la linterna y aumenta el brillo si estás escaneando desde una pantalla. ii. Distancia: Escanear el código QR desde una distancia inadecuada también causará problemas. La distancia óptima para escanear el código QR es de casi 10 pulgadas (25 cm). iii. Lentes de cámara sucias: El código QR también puede fallar al escanear por lentes sucias. Limpia los lentes antes de escanearlo. “¿Ves una cuadrícula en el escáner? Solo ajusta el código QR dentro de ella para escanearlo correctamente.”' },
      { q: '¿Esta herramienta escanea un código QR invertido o de colores?', a: '**Sí**, puedes escanear QR en cualquier color u orientación. Sin embargo, si el contraste entre el color de fondo y de primer plano es bajo, puede causar dificultad para escanear.' },
      { q: '¿Esta herramienta es gratuita?', a: '**Sí**, esta herramienta es totalmente gratuita. Puedes escanear códigos QR ilimitados gratis para siempre.' },
    ],
    faceBlur: [
      { q: '¿Cómo funciona la detección de rostros?', a: 'Usamos un modelo de IA para detección de rostros que se ejecuta directamente en tu navegador. Identifica rostros en la imagen para que puedas aplicar un efecto de desenfoque.' },
      { q: '¿Puedo elegir qué rostros desenfocar?', a: 'Sí. Tras la detección, cada región de rostro se resalta y puedes seleccionar cuáles desenfocar y ajustar la intensidad.' },
      { q: '¿Qué estilos de desenfoque están disponibles?', a: 'Puedes elegir entre desenfoque gaussiano, pixelación o relleno de color sólido. La intensidad de cada efecto es totalmente ajustable.' },
      { q: '¿Puedo desenfocar rostros en varias imágenes a la vez?', a: 'Sí. Sube varias imágenes, configura las regiones de desenfoque y descarga todas las imágenes procesadas.' },
      { q: '¿Se envían mis fotos a un servidor remoto?', a: 'No. El modelo de IA se ejecuta en tu navegador con WebAssembly. Tus fotos nunca se suben a ningún servidor.' },
    ],
    photoEditor: [
      { q: '¿Qué funciones de edición están disponibles?', a: 'Puedes ajustar brillo, contraste, saturación, aplicar filtros, añadir texto, superposiciones, marcos, pegatinas y mucho más, todo en tu navegador.' },
      { q: '¿Puedo deshacer y rehacer cambios?', a: 'Sí. El editor admite historial completo de deshacer/rehacer para que puedas experimentar libremente.' },
      { q: '¿Qué formatos de archivo puedo editar y exportar?', a: 'Puedes editar JPG, PNG, WEBP y otros formatos comunes. La imagen editada se puede exportar en el formato y calidad que prefieras.' },
      { q: '¿El editor funciona en móviles?', a: 'Sí. El editor es totalmente responsive y compatible con pantallas táctiles.' },
      { q: '¿Se almacenan mis imágenes en tus servidores?', a: 'No. Toda la edición se realiza localmente. Tus imágenes nunca abandonan tu dispositivo.' },
    ],
  },
};

export default es;